
// const prdBundleIds = [];
// const prdBundlePrices = [];
// const itsPrdIds = [];
// let presentClickedBtn;
// let isMobile = false;
// // Select the parent element with the class 'prd-bundle-main-container'
// const parentElement = document.querySelector('.prd-bundle-main-container');

// // Find the hidden input elements within the parent container
// const maxBundleLimit = parentElement?.querySelector('input[name="max_bundle_limit"]')?.value;
// const minBundleLimit = parentElement?.querySelector('input[name="min_bundle_limit"]')?.value;
// let variantUnavailable = false;

// function formatBundleMoney(cents, format) {
//   format = format || '${{amount}}';
//   cents = Math.round(Number(cents) || 0);
//   const amount = (cents / 100);
//   const withDecimals = (val, places, thousand, decimal) => {
//     const fixed = Math.abs(val).toFixed(places);
//     const parts = fixed.split('.');
//     parts[0] = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + (thousand || ','));
//     return (val < 0 ? '-' : '') + parts.join(places ? (decimal || '.') : '');
//   };
//   return format
//     .replace(/\{\{\s*amount\s*\}\}/g, withDecimals(amount, 2, ',', '.'))
//     .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, withDecimals(amount, 0, ',', ''))
//     .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withDecimals(amount, 2, '.', ','))
//     .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, withDecimals(amount, 0, '.', ''))
//     .replace(/\{\{\s*amount_with_space_separator\s*\}\}/g, withDecimals(amount, 2, ' ', '.'))
//     .replace(/\{\{\s*amount_no_decimals_with_space_separator\s*\}\}/g, withDecimals(amount, 0, ' ', ''))
//     .replace(/\{\{\s*amount_with_period_and_space_separator\s*\}\}/g, withDecimals(amount, 2, ' ', '.'));
// }

// function updateBundleSummary() {
//   const containers = document.querySelectorAll('.prd-bundle-main-container');
//   if (!containers.length) return;
//   const subtotal = prdBundlePrices.reduce((sum, p) => sum + (Number(p) || 0), 0);
//   containers.forEach(container => {
//     const moneyFormat = container.dataset.moneyFormat || '${{amount}}';
//     const maxQty = parseInt(container.dataset.bundleMax, 10) || parseInt(maxBundleLimit, 10) || 0;
//     const discountPct = parseFloat(container.dataset.bundleDiscount) || 0;
//     const count = prdBundleIds.length;
//     const discountActive = count > 0 && discountPct > 0;
//     const discount = discountActive ? Math.round(subtotal * discountPct / 100) : 0;
//     const total = subtotal - discount;

//     // Step circles — N selected products complete N circles; the next upcoming
//     // step (count + 1) gets the active/current state (green border + green check).
//     const steps = container.querySelectorAll('.prd-bundle-step');
//     steps.forEach(step => {
//       const stepNum = parseInt(step.dataset.step, 10) || 0;
//       step.classList.remove('is-completed', 'is-current', 'is-pending');
//       if (stepNum > 0 && count >= stepNum) step.classList.add('is-completed');
//       // Only highlight the next upcoming step once at least one item is selected.
//       // With nothing selected, every step stays pending so the steps look exactly
//       // like the default (fresh page load) render.
//       else if (stepNum > 0 && count > 0 && stepNum === count + 1) step.classList.add('is-current');
//       else step.classList.add('is-pending');

//       // Completed steps get a small remove (×) icon at the top-left of the circle.
//       // Clicking it unselects the matching bundle item (step N → the Nth selected
//       // item) by triggering that item's existing remove button, so every downstream
//       // behaviour (arrays, placeholders, button states, totals) runs exactly as before.
//       const circle = step.querySelector('.prd-bundle-step__circle');
//       if (circle) {
//         let cross = circle.querySelector('.prd-bundle-step__remove');
//         if (step.classList.contains('is-completed')) {
//           if (!cross) {
//             cross = document.createElement('button');
//             cross.type = 'button';
//             cross.className = 'prd-bundle-step__remove';
//             cross.setAttribute('aria-label', 'Remove this item from the bundle');
//             cross.innerHTML = '&times;';
//             cross.addEventListener('click', (e) => {
//               e.preventDefault();
//               e.stopPropagation();
//               const idx = (parseInt(step.dataset.step, 10) || 0) - 1;
//               // Target the same container the items are added to (see addPrdToBundle),
//               // so the Nth remove button lines up with the Nth selected item.
//               const bundleContainer = document.querySelector('.prd-bundle-container');
//               const removeBtns = bundleContainer
//                 ? bundleContainer.querySelectorAll('.bundle-item .remove-item')
//                 : [];
//               if (idx >= 0 && removeBtns[idx]) removeBtns[idx].click();
//             });
//             circle.appendChild(cross);
//           }
//         } else if (cross) {
//           cross.remove();
//         }
//       }
//     });

//     // Progress line — black up to the last completed step, green from there
//     // to the next upcoming (active) step.
//     const stepsContainer = container.querySelector('.prd-bundle-steps');
//     if (stepsContainer) {
//       let progress = 0;       // fraction of the visible track that's filled (black + green)
//       let completedStop = 0;  // % within the fill bar where black ends and green begins
//       if (maxQty > 1) {
//         progress = Math.min(1, Math.max(0, count / (maxQty - 1)));
//         if (count > 0) {
//           completedStop = (count >= maxQty) ? 100 : ((count - 1) / count) * 100;
//         }
//       } else if (maxQty === 1 && count >= 1) {
//         progress = 1;
//         completedStop = 100;
//       }
//       stepsContainer.style.setProperty('--fill-progress', progress);
//       stepsContainer.style.setProperty('--completed-stop', completedStop + '%');
//     }

//     // Summary: subtotal (compare-at — always visible, strike-through only after 1+ items)
//     const subtotalEl = container.querySelector('.js-bundle-subtotal');
//     if (subtotalEl) {
//       subtotalEl.textContent = formatBundleMoney(subtotal, moneyFormat);
//       subtotalEl.classList.toggle('is-strike', count > 0);
//     }

//     // Savings intro ("You're saving 20%")
//     const introEl = container.querySelector('.js-bundle-savings-intro');
//     if (introEl) {
//       const tpl = container.dataset.textSavingsIntro || "You're saving [percent]%";
//       introEl.textContent = tpl
//         .replace('[percent]', discountPct)
//         .replace('[amount]', formatBundleMoney(discount, moneyFormat));
//     }

//     // Savings amount ("You save $24.00") — always visible; reads $0.00 when nothing selected
//     const savingsAmountEl = container.querySelector('.js-bundle-savings-amount');
//     if (savingsAmountEl) {
//       const tpl = container.dataset.textSavingsAmount || 'You save [amount]';
//       savingsAmountEl.textContent = tpl
//         .replace('[amount]', formatBundleMoney(discount, moneyFormat))
//         .replace('[percent]', discountPct);
//       savingsAmountEl.removeAttribute('hidden');
//     }

//     // Total (big)
//     const totalEl = container.querySelector('.js-bundle-total');
//     if (totalEl) totalEl.textContent = formatBundleMoney(total, moneyFormat);

//     // CTA total
//     const ctaTotalEl = container.querySelector('.js-bundle-cta-total');
//     if (ctaTotalEl) ctaTotalEl.textContent = formatBundleMoney(total, moneyFormat);

//   });
// }



// window.addPrdToBundle = function(prd, title, price, featured_image, bundlePrdId, mobileVariantIdn = null, priceCents = 0) {
//   window.__lastBundlePriceCents = priceCents;
//   // Block add-to-bundle (Quick View + bundle PDP) until Size is selected, matching
//   // the required-size validation on the main product page.
//   const formScope = prd.closest('.product-form');
//   const sizeSelector = formScope?.querySelector('[data-option="Size"], [data-option="size"]');
//   if (sizeSelector && !sizeSelector.querySelector('input:checked')) {
//     const bundleBtnWrap = prd.closest('.bundle-btn');
//     if (bundleBtnWrap) {
//       let warning = bundleBtnWrap.previousElementSibling;
//       if (!warning || !warning.classList.contains('bundle-btn-warning')) {
//         warning = document.createElement('p');
//         warning.className = 'bundle-btn-warning';
//         warning.style.cssText = 'color:#b00020;font-size:0.875rem;font-weight:600;margin:0 0 8px 0;';
//         bundleBtnWrap.parentNode.insertBefore(warning, bundleBtnWrap);
//       }
//       warning.textContent = 'Please select a size before adding to bundle.';
//       if (bundleBtnWrap._warningTimeout) clearTimeout(bundleBtnWrap._warningTimeout);
//       bundleBtnWrap._warningTimeout = setTimeout(() => {
//         warning.remove();
//         bundleBtnWrap._warningTimeout = null;
//       }, 4000);
//     }
//     return;
//   }
  
//   itsPrdIds.push(bundlePrdId);
//   // console.log('itsPrdIds: ', itsPrdIds)
//   if(variantUnavailable) return;

//   const anotherImgPresent = document.querySelector('carousel-slider .slider .slider__item.is-active .product-media img');
//   featured_image = anotherImgPresent.src
  
//   let parent = prd.closest('.product-form');
//   let prd_inv_div = parent.querySelector('.product-inventory');
//   let prd_inv_qty = prd_inv_div.querySelector('.product-inventory__status').dataset.lowQty;
//   prd_inv_qty = parseInt(prd_inv_qty);
//   let isLowInv = !(Array.from(prd_inv_div.attributes).some(i => i.name === 'hidden'));
//   let var_id = prd.closest('buy-buttons').querySelector('form input[name="id"]').value;

//   // console.log({prd_inv_qty,prdBundleIds_12345: prdBundleIds.filter(item => item === var_id).length});

//   if(isLowInv){
//     let count = prdBundleIds.filter(item => item === var_id).length;
//     if(prd_inv_qty == count ){ prd.innerHTML = "Out Of Stock"; prd.setAttribute('disabled',''); return; }
//   }

//   if(prdBundleIds.length > (maxBundleLimit-1)) return;
  
//   if(mobileVariantIdn)presentClickedBtn = prd; isMobile = true
//   // console.log('bundlePrdId: ', bundlePrdId)

//   const bundleContainer = document.querySelector('.prd-bundle-container');
//   const productDiv = document.createElement('div');
//   productDiv.classList.add('bundle-item');

//   const img = document.createElement('img');
//   img.src = featured_image;
//   img.alt = title;
//   img.classList.add('bundle-item-image');
//   productDiv.appendChild(img);

//   const prdId = findIdForBundle(prd, mobileVariantIdn);  

//   const removeBtn = document.createElement('span');
//   removeBtn.classList.add('remove-item');
//   removeBtn.innerText = '×';
//   removeBtn.setAttribute('data-id', prdId);

//   removeBtn.addEventListener('click', () => {
//     const productId = removeBtn.getAttribute('data-id');
//     const productIndex = prdBundleIds.indexOf(productId);
//     if (productIndex > -1) {
//       prdBundleIds.splice(productIndex, 1);
//       itsPrdIds.splice(productIndex, 1);
//       prdBundlePrices.splice(productIndex, 1);
//     }
//     // console.log('itsPrdIds: ', itsPrdIds)
//     productDiv.remove();
//     if (prdBundleIds.length < minBundleLimit) document.querySelectorAll('.prd-bundle-AddToCart').forEach(el => el.classList.add('disabled'));
//     if (mobileVariantIdn) changeBtnText(prd, true);
//     else changeBtnText(document.getElementById(bundlePrdId), true);
//     if (prdBundleIds.length < maxBundleLimit) disableAllBtns(false);

//     // Append placeholder if there are no more products
//     if (prdBundleIds.length < maxBundleLimit) {
//         const placeholderDiv = document.createElement('div');
//         placeholderDiv.classList.add('bundle-item');
//         const placeholderImg = document.createElement('img');
//         placeholderImg.src = "https://cdn.shopify.com/s/files/1/1106/6370/files/placeholder.png?v=1739168958";
//         placeholderImg.alt = "Placeholder image";
//         placeholderImg.classList.add('bundle-placeholder-img');
//         placeholderDiv.appendChild(placeholderImg);
//         bundleContainer.appendChild(placeholderDiv);
//     }
//     updateBundleSummary();
//   });

//   productDiv.appendChild(removeBtn);

//   // Check if a placeholder exists
//   const placeholderImage = bundleContainer.querySelector('.bundle-placeholder-img');

//   if (placeholderImage) {
//       // Insert before placeholder if it exists
//       bundleContainer.insertBefore(productDiv, placeholderImage.closest('.bundle-item'));
//   } else {
//       // If no placeholder, insert at the start of the container
//       bundleContainer.appendChild(productDiv);
//   }

//   // Remove placeholder if product is added
//   if (placeholderImage) { placeholderImage.closest('.bundle-item').remove() }

//   const targetDiv = document.querySelector('.filter-container .filters .filters__inner');
//   const targetDivScroll = document.querySelector('.filter-container .filters');
//   if (targetDiv) {
//       let scrollHeightDiv = targetDivScroll.scrollHeight + bundleContainer.scrollHeight; 
//       setTimeout(()=>{ targetDivScroll.scrollTop = scrollHeightDiv },200)
//       // console.log('adddded',scrollHeightDiv );
//   } // else { console.log("Div not found!"); }
// }


// function findIdForBundle(prd, mobileVariantIdn) {
//     if(!mobileVariantIdn){
//         const productIdInput = document.querySelector('input[name="id"]');
//         if (productIdInput) {
//             thisisId(prd, productIdInput.value);
//         } else {
//             console.error('Product ID input not found!');
//         }
//         return(productIdInput.value);
//     }
//     else{
//         thisisId(prd, mobileVariantIdn);
//         return(mobileVariantIdn);
//     }
// }

// function thisisId(prd, id) {
//     prdBundleIds.push(id);
//     const priceCentsToTrack = parseInt(window.__lastBundlePriceCents, 10) || 0;
//     prdBundlePrices.push(priceCentsToTrack);
//     // console.log('prdBundlesIds: ', prdBundleIds)
//     if(prdBundleIds.length == maxBundleLimit ){
//         disableAllBtns(true);

//     }
//     if (prdBundleIds.length >= minBundleLimit) {
//         document.querySelectorAll('.prd-bundle-AddToCart').forEach(el => el.classList.remove('disabled'));
//     }
//     const parentContainer = prd.closest('.quickbuy-container');
//     if (parentContainer) {
//         const closeButton = parentContainer.querySelector('.close-detail');
//         if (closeButton) {
//             closeButton.click();
//         }
//     }
//     changeBtnText(presentClickedBtn);
//     updateBundleSummary();
// }

// function bundlePopupOpen(btn) {  
//   if(prdBundleIds.length > (maxBundleLimit-1)) return;
//   presentClickedBtn = btn;
//   const parentContainer = btn.closest('.image-cont');
//   const quickbuyButton = parentContainer.querySelector('.quickbuy-toggle');
//   if (quickbuyButton) {
//       quickbuyButton.click();
//   }
// }

// function openQuickView(e, btn, product_id){  
//   e.preventDefault();
//   if(prdBundleIds.length > (maxBundleLimit-1)) return;
//   const parentContainer = btn.closest('.image-cont') || btn.closest('.block-inner-inner');
//   presentClickedBtn = parentContainer.querySelector('.bundle-popup-open p');
//   const quickbuyButton = parentContainer.querySelector('.quickbuy-toggle');
//   if (quickbuyButton) {
//       quickbuyButton.click();
//   }
// }

// function changeBtnText(btn, remove=false){
//     // console.log('changeBtnText btn: ', btn)
//     // if(remove){
//     //     btn.innerText = 'Add To Bundle';
//     //     btn.closest('.bundle-popup-open').classList.remove('disabled');

//     // }
//     // else{
//     //     btn.innerText = 'Added';
//     //     btn.closest('.bundle-popup-open').classList.add('disabled');
//     // }
// }

// function disableAllBtns(disable){
//     if(disable){
//         document.querySelectorAll('.bundle-popup-open p').forEach((singleBtn)=>{
//             singleBtn.style.opacity = '0.5'
//             singleBtn.style.cursor = 'default'
//         })
//     }
//     else{
//         document.querySelectorAll('.bundle-popup-open p').forEach((singleBtn)=>{
//             singleBtn.style.opacity = '1'
//             singleBtn.style.cursor = 'pointer'
//         })
//     }
// }

// // function updateBundleBtn(){
// //   itsPrdIds.forEach((bundlePrdId)=>{
// //     changeBtnText(document.getElementById(bundlePrdId), false);
// //   })
// // }

// async function addBundleToCart(btn) {
//     btn.innerText = 'Loading..'
//     const formData = { items: prdBundleIds.map(id => ({ id, quantity: 1 })) };
//     try {
//         let discount_code = btn.closest('.prd-bundle-AddToCart').dataset.discountCode;
//         await fetch(`/discount/${discount_code}`)

//         const response = await fetch('/cart/add.js', {
//             method: 'POST',
//             headers: { 'Content-Type': 'application/json' },
//             body: JSON.stringify(formData)
//         });
//         const data = await response.json();
//         if (data && data.items) {
//             if (window.klaviyoTrackAddToCart) window.klaviyoTrackAddToCart(data);
//             $('.cart-link__icon').load(location.href + ' .cart-link__icon');
//             const cartDrawer = document.querySelector('cart-drawer');
//             if(cartDrawer){
//               cartDrawer.cartRefreshHandler();
//               cartDrawer.open();
//               btn.innerText = 'Add To Cart'
//             }
//         }
//     } catch (error) {
//         console.error('Error: ', error);
//     }
// }



// document.addEventListener('DOMContentLoaded', function() {
//   const element = document.querySelector('.filter-container.filter-container--side.bundle-collection');
//   const mobileContainer = document.querySelector('.prd-bundle-main-container.for_mobile');
//   const desktopHeading = document.querySelector('.filter-group__heading__text.for_desktop');
//   const desktopContainer = document.querySelector('.prd-bundle-main-container.for_desktop');
  
//   // Show the filter group items
//   document.querySelectorAll('.filter-group__heading').forEach(item => item.style.pointerEvents = 'none' );

//   document.querySelectorAll('.filter-group__heading.toggle-target-toggler--is-hidden').forEach(item => item.classList.remove('toggle-target-toggler--is-hidden'));
//   document.querySelector('.filter-group__items.filter-group--3.toggle-target.toggle-target--hidden')?.classList.remove('toggle-target--hidden');

//   // Corrected the variable names in the console log
//   // console.log('mobileContainer: ', mobileContainer, ' desktopHeading: ', desktopHeading, ' desktopContainer: ', desktopContainer);

//   // Handle display based on screen size
//   if (window.innerWidth <= 999) {
//     element?.classList.replace('filter-container--show-filters-desktop', 'filter-container--show-filters-mobile');
//     if (mobileContainer) { mobileContainer.style.display = 'block'}
//     if (desktopHeading) { desktopHeading.remove() }
//     if (desktopContainer) { desktopContainer.remove() }

//     const mobileFiltersWrap = document.querySelector('.filter-container .filters.mobile-sticky-maincontainer');
//     const desktopFiltersWrap = document.querySelector('.filter-container .filters:not(.mobile-sticky-maincontainer)');
//     if (mobileFiltersWrap && desktopFiltersWrap) {
//       mobileFiltersWrap.addEventListener('change', (evt) => {
//         const src = evt.target;
//         if (!src || !src.matches || !src.matches('input, select, textarea')) return;
//         const escName = CSS.escape(src.name);
//         if (src.type === 'radio') {
//           desktopFiltersWrap.querySelectorAll(`input[type="radio"][name="${escName}"]`).forEach((el) => {
//             el.checked = (el.value === src.value);
//           });
//         } else if (src.type === 'checkbox') {
//           const dst = desktopFiltersWrap.querySelector(`input[type="checkbox"][name="${escName}"][value="${CSS.escape(src.value)}"]`);
//           if (dst) dst.checked = src.checked;
//         } else {
//           const dst = desktopFiltersWrap.querySelector(`[name="${escName}"]`);
//           if (dst) dst.value = src.value;
//         }
//       });
//     }
//   } else {
//     element?.classList.replace('filter-container--show-filters-mobile', 'filter-container--show-filters-desktop');
//     if (desktopHeading) { desktopHeading.style.display = 'block' }
//     if (desktopContainer) { desktopContainer.style.display = 'block' }
//     if (mobileContainer) { mobileContainer.remove() }
//   }
// });


// /* 

// console.log('working custom-mw.js');

// const prdBundleIds = [];
// let presentClickedBtn;
// // Select the parent element with the class 'prd-bundle-main-container'
// const parentElement = document.querySelector('.prd-bundle-main-container');

// // Find the hidden input elements within the parent container
// const maxBundleLimit = parentElement.querySelector('input[name="max_bundle_limit"]').value;
// const minBundleLimit = parentElement.querySelector('input[name="min_bundle_limit"]').value;

// // Log the values to the console (you can also use these values in your code)
// console.log('Max Bundle Limit:', maxBundleLimit);
// console.log('Min Bundle Limit:', minBundleLimit);


// function addPrdToBundle(prd, title, price, featured_image, bundlePrdId) {
//     console.log('bundlePrdId: ', bundlePrdId)
//     const bundleContainer = document.querySelector('.prd-bundle-container');
//     const productDiv = document.createElement('div');
//     productDiv.classList.add('bundle-item');

//     const img = document.createElement('img');
//     img.src = featured_image;
//     img.alt = title;
//     img.classList.add('bundle-item-image');
//     productDiv.appendChild(img);

//     const prdId = findIdForBundle(prd);

//     const removeBtn = document.createElement('span');
//     removeBtn.classList.add('remove-item');
//     removeBtn.innerText = '×';

//     removeBtn.setAttribute('data-id', prdId);

//     removeBtn.addEventListener('click', () => {
//         const productId = removeBtn.getAttribute('data-id');
//         const productIndex = prdBundleIds.indexOf(productId);
//         if (productIndex > -1) prdBundleIds.splice(productIndex, 1);
//         console.log('prdBundleIds after: ', prdBundleIds)
//         productDiv.remove();
//         if (prdBundleIds.length < minBundleLimit ) document.querySelector('.prd-bundle-AddToCart').classList.add('disabled');
//         changeBtnText( document.getElementById(bundlePrdId) , true);
//         if(prdBundleIds.length < maxBundleLimit ) disableAllBtns(false);
//     });

//     productDiv.appendChild(removeBtn);
//     bundleContainer.appendChild(productDiv);
// }


// function findIdForBundle(prd) {
//     const productIdInput = document.querySelector('input[name="id"]');
//     if (productIdInput) {
//         thisisId(prd, productIdInput.value);
//     } else {
//         console.error('Product ID input not found!');
//     }
//     return(productIdInput.value);
// }

// function thisisId(prd, id) {
//     prdBundleIds.push(id);
//     console.log('prdBundlesIds: ', prdBundleIds)
//     if(prdBundleIds.length == maxBundleLimit ){
//         disableAllBtns(true);
       
//     }
//     if (prdBundleIds.length >= minBundleLimit) {
//         document.querySelector('.prd-bundle-AddToCart').classList.remove('disabled');
//     }
//     const parentContainer = prd.closest('.quickbuy-container');
//     if (parentContainer) {
//         const closeButton = parentContainer.querySelector('.close-detail');
//         if (closeButton) {
//             closeButton.click();
//         }
//     }
//     changeBtnText(presentClickedBtn);
// }

// function bundlePopupOpen(btn) {    
//     if(prdBundleIds.length > (maxBundleLimit-1)) return;
//     presentClickedBtn = btn;
//     const parentContainer = btn.closest('.image-cont');
//     const quickbuyButton = parentContainer.querySelector('.quickbuy-toggle');
//     if (quickbuyButton) {
//         quickbuyButton.click();
//     }
// }

// function changeBtnText(btn, remove=false){
//     console.log('changeBtnText btn: ', btn)
//     if(remove){
//         btn.innerText = 'Add To Bundle';
//         btn.closest('.bundle-popup-open').classList.remove('disabled');

//     }
//     else{
//         btn.innerText = 'Added';
//         btn.closest('.bundle-popup-open').classList.add('disabled');
//     }
// }

// function disableAllBtns(disable){
//     if(disable){
//         document.querySelectorAll('.bundle-popup-open p').forEach((singleBtn)=>{
//             singleBtn.style.opacity = '0.5'
//             singleBtn.style.cursor = 'default'
//         })
//     }
//     else{
//         document.querySelectorAll('.bundle-popup-open p').forEach((singleBtn)=>{
//             singleBtn.style.opacity = '1'
//             singleBtn.style.cursor = 'pointer'
//         })
//     }
// }

// async function addBundleToCart(btn) {
//     btn.innerText = 'Loading..'
//     const formData = {
//         items: prdBundleIds.map(id => ({ id, quantity: 1 }))
//     };
//     try {
//         const response = await fetch('/cart/add.js', {
//             method: 'POST',
//             headers: { 'Content-Type': 'application/json' },
//             body: JSON.stringify(formData)
//         });
//         const data = await response.json();
//         if (data && data.items) {
//             window.location.href = '/cart';
//             // const drawer = document.querySelector('.drawer');
//             // if (!drawer.classList.contains('active')) {
//             //     drawer.classList.remove("is-empty");
//             //     drawer.classList.add("active");
//             //     drawer.setAttribute('open', 'true');
//             //     document.body.classList.add('overflow-hidden');
//             // }
//             // $('.drawer').load(location.href + ' .cart-drawer');
//             // $('.cart-link__icon').load(location.href + ' .cart-link__icon');
//         }
//     } catch (error) {
//         console.error('Error: ', error);
//     }
// }

// */



// // -----------------------------------------
  
// let finalSelectedVariants = [];
// const discountPer = (100 - document.querySelector('[color_discount]')?.getAttribute('color_discount')) / 100 || null;

// function colorsInputChangeHandler(inpElm, optName, optionSelectedValue) {
  
//   // variantUnavailable = inpElm.classList.contains('is-unavailable');
//   setTimeout(() => {
//     let get_all_checked_inputs = inpElm?.closest('variant-picker').querySelectorAll('input:checked');
//     variantUnavailable =  Array?.from(get_all_checked_inputs)?.some( i => i.classList.contains('is-unavailable'))
  
//     let bundle_btn = inpElm.closest('.product-form').querySelector('.bundle-btn .add-to-bundle');
//     if(variantUnavailable){ bundle_btn.innerHTML = 'Out Of Stock'; bundle_btn.setAttribute('disabled','') }
//     else{ bundle_btn.innerHTML = 'Add To Bundle'; bundle_btn.removeAttribute('disabled','') }
//   }, 100);

//   // console.log('prdBundleIds colorsInputChangeHandler',prdBundleIds);
  


//   const colorBundle = document.querySelector('.color_bundle');
//   if(!colorBundle){ return } 

//   const variantScript = document.querySelector('variant-picker script');
//   const variantsData = JSON.parse(variantScript.textContent);
    
//   if (optionSelectedValue) {
//     const optionSelector = inpElm.closest('.customSwatchesCon');
//     const spanHeadingColor = optionSelector.querySelector('.option-selector__label-value');
//     spanHeadingColor.innerText = inpElm.value;
//   }

//   const checkedInputSize = document.querySelector('fieldset[data-option="Size"] input:checked');
//   const allCheckedInputColor = document.querySelectorAll('fieldset[data-option="Color"] input:checked');
//   let selectedOptions = [];

//   if (!inpElm) {
//     handleUnavailableVariants(checkedInputSize);
//     return;
//   }

//   if (optName === 'Color') {
//     handleColorSelection(inpElm, checkedInputSize);
//   } else if (allCheckedInputColor?.length > 0) {
//     allCheckedInputColor.forEach(checkedInputColor => handleVariantSelection(inpElm, checkedInputSize, checkedInputColor));
//   }

//   updateAddToCartButton();

//   function handleColorSelection(inpElm, checkedInputSize) {
//     selectedOptions = [checkedInputSize.value, inpElm.value];
//     const selectedVariant = findSelectedVariant(selectedOptions);
//     updateSelectedOptions(inpElm.name, selectedVariant?.id, selectedVariant.featured_image, selectedVariant.featured_media.id, selectedVariant.price, selectedVariant?.compare_at_price);

//     if (!selectedVariant?.available) {
//       removeUnavailableVariant(selectedVariant);
//     }
//   }

//   function handleVariantSelection(inpElm, checkedInputSize, checkedInputColor) {
//     selectedOptions = [inpElm.value, checkedInputColor.value];
//     const selectedVariant = findSelectedVariant(selectedOptions);

//     updateSelectedOptions(checkedInputColor.name, selectedVariant?.id, selectedVariant.featured_image, selectedVariant.featured_media.id, selectedVariant.price, selectedVariant?.compare_at_price);
//     resetUnavailableClasses();

//     const unavailableVariants = findUnavailableVariants(checkedInputSize.value);
//     if (unavailableVariants?.length > 0) {
//       markUnavailableVariants(unavailableVariants);
//     }
//   }

//   function findSelectedVariant(options) {
//     return variantsData.variants.find(v => v.options.every((val, index) => val === options[index]));
//   }

//   function updateSelectedOptions(name, value, featureImgSrc, featuredMediaId, variantPrice, compareAtPrice = null) {

//   // console.log(selectedOptions,'selected options here');
  
  
//     const sideImagesWrapper = document.querySelector('.side-images-wrapper');
    
//     // Check if the side-images-container already exists by looking for the specific id
//     let sideImageContainer = document.getElementById(`side-img-${name}`);

//     const firstMainImage = document.querySelector(`.product-media-collage [data-media-id="${featuredMediaId}"]`);
//     const mainImage = firstMainImage?.querySelector(`img`);
//     document.querySelector('[imgActive]')?.removeAttribute('imgActive');

//   if(sideImageContainer){
//     const imgElement = sideImageContainer.querySelector('img');
//     const mediaId = sideImageContainer.getAttribute('featured-media-id');

//       if (imgElement) {
//           imgElement.src = featureImgSrc.src;
//           imgElement.alt = featureImgSrc.alt;
//           // imgElement.removeAttribute('featured-media-id');
//           sideImageContainer.setAttribute('featured-media-id', featuredMediaId);
//           sideImageContainer.setAttribute('imgActive', '');
          
//           sideImageContainer.setAttribute('options-atr', `${selectedOptions[0]}-----${selectedOptions[1]}`);
          

//       }
//       }else{
//         sideImageContainer = document.createElement('div');
//         sideImageContainer.classList.add('side-images-container');
//         sideImageContainer.id = `side-img-${name}`;
//         sideImageContainer.setAttribute('featured-media-id', featuredMediaId);
//         sideImageContainer.setAttribute('imgActive', '');
//         sideImageContainer.setAttribute('options-atr', `${selectedOptions[0]}-----${selectedOptions[1]}`);
//         sideImageContainer.addEventListener('click',()=>{
//           sideImagesMediaChange(`side-img-${name}`);
//         })

//         // Create the image element
//         const imgElement = document.createElement('img');
//         imgElement.classList.add('slider-image');
//         imgElement.src = featureImgSrc.src;
//         imgElement.alt = featureImgSrc.alt;

//         // Append the image element to the container
//         sideImageContainer.appendChild(imgElement);

//         // Append the new container to the side-images-wrapper
//         sideImagesWrapper.appendChild(sideImageContainer);
  
//   }

//     const existingOptionIndex = finalSelectedVariants.findIndex(option => option[name] !== undefined);
//     if (existingOptionIndex !== -1) {
//       finalSelectedVariants[existingOptionIndex][name] = value;
//       finalSelectedVariants[existingOptionIndex].price = variantPrice;
//       finalSelectedVariants[existingOptionIndex].compareAtPrice = compareAtPrice;
//       finalSelectedVariants[existingOptionIndex].featuredMediaId = featuredMediaId;

//     } else {
//       finalSelectedVariants.push({ [name]: value, price: variantPrice, compareAtPrice: compareAtPrice, featuredMediaId:featuredMediaId });
//     }

//   }

//   function handleUnavailableVariants(checkedInputSize) {
//     if (allCheckedInputColor?.length > 0) {
//       allCheckedInputColor.forEach(checkedInputColor => {        
//         selectedOptions = [checkedInputSize.value, checkedInputColor.value];
//         const selectedVariant = findSelectedVariant(selectedOptions);
//         updateSelectedOptions(checkedInputColor.name, selectedVariant?.id, selectedVariant.featured_image, selectedVariant.featured_media.id, selectedVariant.price, selectedVariant?.compare_at_price);
//       });
//     }

//     resetUnavailableClasses();
//     const unavailableVariants = findUnavailableVariants(checkedInputSize.value);
//     if (unavailableVariants?.length > 0) {
//       markUnavailableVariants(unavailableVariants);
//     }
//   }

//   function resetUnavailableClasses() {
//     document.querySelectorAll('.customSwatchesCon input[type="radio"].is-unavailable')
//       .forEach(elm => elm.classList.remove('is-unavailable'));

//        document.querySelectorAll('variant-picker input[type="radio"].is-unavailable')
//       .forEach(elm => elm.classList.remove('is-unavailable'));
//   }

//   function findUnavailableVariants(sizeValue) {
//     return variantsData.variants.filter(v => v.option1 === sizeValue && !v.available);
//   }

//   function markUnavailableVariants(unavailableVariants) {
//     unavailableVariants.forEach(unavailableItem => {
//       document.querySelectorAll(`.customSwatchesCon input[value='${unavailableItem.option2}']`)
//         .forEach(elm => elm.classList.add('is-unavailable'));

//          document.querySelectorAll(`variant-picker input[value='${unavailableItem.option2}']`)
//         .forEach(elm => elm.classList.add('is-unavailable'));
//       removeUnavailableVariant(unavailableItem);
//     });
//   }

//   function removeUnavailableVariant(variant) {
//     finalSelectedVariants = finalSelectedVariants.filter(obj => !Object.values(obj).some(value => value === variant.id));
//   }

//   function updateAddToCartButton() {
//     const customAddToCartBtn = document.querySelector('.custom-add-to-cart-btn');
//     if (customAddToCartBtn) {
//       if (finalSelectedVariants.length > 0) {
//         customAddToCartBtn.innerText = "Add To Cart";
//         customAddToCartBtn.removeAttribute('disabled');
//       } else {
//         customAddToCartBtn.setAttribute('disabled', true);
//         customAddToCartBtn.innerText = "Sold Out";
//       }
//     }
//   }

//   // console.log('hi lovovovdsjojd');
//   if (optName === 'Size') {
//     document.querySelector('[imgactive]')?.removeAttribute('imgactive');
//     const sideImagesContainer = document.querySelectorAll('.side-images-container');
//     if(sideImagesContainer?.length > 0){
//       sideImagesContainer.forEach((itm,i)=>{
//         if(i==0){
//           itm.setAttribute('imgactive', '');
//         }
//       })
//     }
//   }
  
//   const activeMediaObj = document.querySelector('.custom-media-gall-cls media-gallery');
//   // console.log(activeMediaObj,'media gg');

//   // if(activeMediaObj){ activeMediaObj.style.pointerEvents = 'none' }
//   const boundOnVariantChange = activeMediaObj.onVariantChange.bind(activeMediaObj);

//   // Calling the method manually
//   boundOnVariantChange({
//       type: 'on:variant:change',   // Event type (optional)
//       detail: { selectedOptions: selectedOptions },  // Event data
//   });


//   if(finalSelectedVariants.length > 1){
//     const sideImagesWrapper = document.querySelector('.side-images-wrapper');
//     if(sideImagesWrapper){ sideImagesWrapper.classList.remove('hidden') }

//     const customAddToCartBtn2 = document.querySelector('.custom-add-to-cart-btn');
//     const allInputColorSelectors = document.querySelectorAll('fieldset[data-option="Color"] .option-selector__btns');
//     if(allInputColorSelectors?.length == finalSelectedVariants?.length){ customAddToCartBtn2.style.opacity = 1 }
//   }
// }

// document.addEventListener('DOMContentLoaded', function () {
//   const colorBundle = document.querySelector('.color_bundle');
//   if(colorBundle){
//     // console.log('color bundle class found');
    
//     colorsInputChangeHandler();
//   }
// });


// function addToCartBundleVariants(e,btnElm){    
//   e.preventDefault();


//   const allInputColorSelectors = document.querySelectorAll('fieldset[data-option="Color"] .option-selector__btns');
//   const qtySubmitRow = btnElm.closest('.quantity-submit-row__submit');

//   if(allInputColorSelectors?.length !== finalSelectedVariants?.length){
//     const customVariantSelectionMsg = qtySubmitRow.querySelector('.custom-variant-selection-msg');
//     if(customVariantSelectionMsg){
//       // customVariantSelectionMsg.classList.remove('hidden');
//       customVariantSelectionMsg.style.visibility = 'initial'
//       customVariantSelectionMsg.style.height = 'auto'
//     }
//     setTimeout(()=>{
//       // customVariantSelectionMsg.classList.add('hidden');
//       customVariantSelectionMsg.style.visibility = 'hidden'
//       customVariantSelectionMsg.style.height = '0'
//     },3000)
//     return;
//   }
  
//   const allCheckedCus = document.querySelectorAll('.customSwatchesCon input:checked');

// // if(finalSelectedVariants.length <= 0){
// //   return;
// // }

// const items = finalSelectedVariants?.map(itm=>({ 'id': Object.values(itm)[0], 'quantity' : 1, properties: {_color_bundle: 'bundle'} }))
// // console.log(items, 'items here');

// // return

//   try {
//     // btnElm.closest('.quantity-submit-row__submit')?.classList.add('js-product-form');
//   btnElm.setAttribute('aria-disabled', 'true');
//   btnElm.classList.add('is-loading');

//     let formData = {
//     'items': items
//     };

//     fetch('/cart/add.js', {
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/json'
//       },
//       body: JSON.stringify(formData)
//     })
//     .then(response => {
//       return response.json();
//     }).then(res=>{
//       if (window.klaviyoTrackAddToCart) window.klaviyoTrackAddToCart(res);

//       // const cartDrawer = document.querySelector('cart-drawer');
//       // if(cartDrawer){
//       //   cartDrawer.cartRefreshHandler();
//       //   cartDrawer.open();
//       // }
//       btnElm.classList.add('is-success');
//         btnElm.removeAttribute('aria-disabled');


//         setTimeout(() => {
//           if(allCheckedCus.length > 0){
//             allCheckedCus.forEach((elm)=>{
//               elm.checked = false;
//             })
//           }
//           btnElm.classList.remove('is-loading');
//           btnElm.classList.remove('is-success');
//           window.location.href = '/cart';
//         }, 2000);
//         })
//     .catch((error) => {
//       console.error('Error:', error);
//     });
//   } catch (error) {
//     console.log(error,'err here');

//   }
// }

// function stickyAtcCusButtonHanlder(e){
//   e.preventDefault();
//   const customAddToCartBtn = document.querySelector('.custom-add-to-cart-btn');
//   if(customAddToCartBtn){
//     window.scrollTo(0, 100);
//     customAddToCartBtn.click();
//   }
// }

// function sideImagesMediaChange(id){
  
//   const sideImagesContainer = document.getElementById(id);
//   // console.log(sideImagesContainer, 'sideImagesContainer');
//   if(sideImagesContainer){
//     const curOptions = sideImagesContainer.getAttribute('options-atr');
//     const selectedOpts = curOptions.split("-----");


//     document.querySelector('[imgactive]')?.removeAttribute('imgactive');
//     //   document.querySelectorAll('.no-hidden')?.forEach(img => img.classList.replace('no-hidden', 'hidden'))
//     //   handlePrdImage(document.querySelector(`.product-media-collage [data-media-id="${featuredMediaId}"]`))
//     // }
//     const activeMediaObj2 = document.querySelector('.custom-media-gall-cls media-gallery');
    
//     const boundOnVariantChange = activeMediaObj2.onVariantChange.bind(activeMediaObj2);
    
//     // Calling the method manually
//     boundOnVariantChange({
//       type: 'on:variant:change',   // Event type (optional)
//       detail: { selectedOptions: selectedOpts },  // Event data
//     });

//     sideImagesContainer.setAttribute('imgactive', '');

//   }

// }




// const targetElements = document.querySelectorAll("cart-form");
// let mutationTimeout;

// const free_gift_mutation = (mutationsList) => {
//     clearTimeout(mutationTimeout);
//     mutationTimeout = setTimeout(() => { free_gift_Updates() }, 500);
// };

// //////
// // function removeHashFromUrl(url) { return url.replace(/:(\w+)(?=&|$)/, '') }
// // function removeFreeGift(id){
// //   let item = document.querySelector(`cart-form .cart-item-list .cart-item[data-product-id="${id}"]`);
// //   let qty_div = item.querySelector('.cart-item__quantity .quantity');
// //   let qty_inp = qty_div.querySelector('input');
// //   let dec_btn = qty_div.querySelector('#updates_dec_1');
// //   qty_inp.value = 1;
// //   dec_btn.click();
// // }
// ////

// // const free_gift_Updates = () => {
// //     // console.log("Cart drawer changed! Running necessary updates...");

// //     let free_gift_parent = document.getElementById('cart_free_gift--wrapper');
// //     let free_gift_progress = free_gift_parent.querySelector('[data-free-shipping-progress]')?.getAttribute('data-free-shipping-progress');
// //     let free_gift_prd_id = free_gift_parent.getAttribute('data-free-gift-id'); 
// //     let cart_drawer_list = document.querySelectorAll('cart-form .cart-item-list .cart-item');

// //     let free_gift_add_form = free_gift_parent.querySelector('.cart_free_gift__add_form product-form');
// //     let free_gift_locked = free_gift_parent.querySelector('.ctm_btn--locked');
// //     let cart_item_ids = Array.from(cart_drawer_list).map(e => e.getAttribute('data-product-id'));

// //     let count = cart_item_ids.filter(id => id === free_gift_prd_id).length; ////////////    

// //     if(cart_drawer_list.length > 0){ free_gift_parent.classList.remove('cart-drawer__footer--hidden') }
// //     else{ free_gift_parent.classList.contains('cart-drawer__footer--hidden') ? '' : free_gift_parent.classList.add('cart-drawer__footer--hidden') ; }

// //     if(!cart_item_ids.includes(free_gift_prd_id)){
// //       if(free_gift_progress != '1'){
// //         free_gift_add_form.style.display = 'none';
// //         free_gift_locked.style.display = 'block';
// //       }else{
// //         free_gift_add_form.style.display = 'block';
// //         free_gift_locked.style.display = 'none';
// //       }
// //     }else{

// //       // if(free_gift_progress != '1'){ removeFreeGift(free_gift_prd_id) } //////////////
// //       // else if(count > 1){ removeFreeGift(free_gift_prd_id) } /////////////

// //       free_gift_add_form.style.display = 'none';
// //       free_gift_locked.style.display = 'block';
// //     }
// // };

// const free_gift_Updates = () => {
//     // console.log("Cart drawer changed! Running necessary updates...");

//     let cart_drawer_list = document.querySelectorAll('cart-form .cart-item-list .cart-item');
//     let cart_item_ids = Array.from(cart_drawer_list).map(e => e.getAttribute('data-product-id'));

//     /* Toggle the form / locked button on a single threshold-gift wrapper. Reused for both
//        the 2nd-threshold (#cart_free_gift--wrapper) and 3rd-threshold
//        (#cart_second_threshold_gift--wrapper) cards so each one's quantity selector hides
//        once its product is added and reappears when the product is removed. */
//     const updateGiftWrapper = (wrapperId, idAttr) => {
//       const parent = document.getElementById(wrapperId);
//       if (!parent) return;

//       const prd_id = parent.getAttribute(idAttr);
//       const add_form = parent.querySelector('.cart_free_gift__add_form product-form');
//       const locked   = parent.querySelector('.ctm_btn--locked');
//       const giftCard = parent.querySelector('.cart_free_gift');
//       if (!prd_id || !add_form || !locked) return;

//       if (cart_drawer_list.length > 0) {
//         parent.classList.remove('cart-drawer__footer--hidden');
//       } else if (!parent.classList.contains('cart-drawer__footer--hidden')) {
//         parent.classList.add('cart-drawer__footer--hidden');
//       }

//       const progressEl = parent.querySelector('[data-free-shipping-progress]');
//       const progress = progressEl ? progressEl.getAttribute('data-free-shipping-progress') : '1';

//       if (!cart_item_ids.includes(prd_id)) {
//         if (giftCard) giftCard.style.display = '';
//         if (progress != '1') {
//           add_form.style.display = 'none';
//           locked.style.display = 'block';
//         } else {
//           add_form.style.display = 'block';
//           locked.style.display = 'none';
//         }
//       } else {
//         if (giftCard) giftCard.style.display = 'none';
//       }
//     };

//     updateGiftWrapper('cart_free_gift--wrapper', 'data-free-gift-id');
//     updateGiftWrapper('cart_second_threshold_gift--wrapper', 'data-second-threshold-id');
// };

// const observer = new MutationObserver(free_gift_mutation);
// const config = { childList: true, attributes: true, characterData: true, subtree: true };
// targetElements.forEach(element => observer.observe(element, config));

// //////////////////////////////////////////////////////////////////////
// {
// //   document.querySelector('.ctm_btn.add-to-cart')?.addEventListener('click', function () {
// //     // console.log('clicked');
// //     const freeGiftPrdId = document.querySelector('.cart_free_gift__add_form--var-selector')?.value;
// //     if (!freeGiftPrdId) return;

// //     const items = [{
// //       id: freeGiftPrdId,
// //       quantity: 1
// //     }];

// //     try {
// //       const formData = { items };
// //       fetch('/cart/add.js', {
// //         method: 'POST',
// //         headers: { 'Content-Type': 'application/json' },
// //         body: JSON.stringify(formData)
// //       })
// //       .then(response => {
// //         if (response.ok) {
// //           location.reload();
// //         } else {
// //           throw new Error('Failed to add item');
// //         }
// //       })
// //       .catch(error => console.error('Error:', error));
// //     } catch (error) {
// //       console.error('Error:', error);
// //     }
// //   });
  
// // }

// /* Refresh the cart-form via Section Rendering API instead of doing a full page reload —
//      keeps observers, scroll position, and other client state intact while the threshold
//      bars/cards/items re-render with up-to-date server state. */
//   const refreshCartFromSections = (sectionId) => {
//     if (!sectionId) return Promise.resolve();
//     return fetch('/?sections=' + encodeURIComponent(sectionId), { credentials: 'same-origin' })
//       .then(r => r.json())
//       .then(data => {
//         const html = data[sectionId];
//         if (!html) return;
//         const doc = new DOMParser().parseFromString(html, 'text/html');
//         const newCartForm = doc.querySelector('cart-form[data-section-id="' + sectionId + '"]') || doc.querySelector('cart-form');
//         const curCartForm = document.querySelector('cart-form[data-section-id="' + sectionId + '"]') || document.querySelector('cart-form');
//         if (newCartForm && curCartForm) {
//           curCartForm.innerHTML = newCartForm.innerHTML;
//           /* Drawer cart items (and cross-sell blocks) render with loading="manual", i.e.
//              data-manual-src instead of src. The merge path activates these on
//              'on:cart:after-merge', but this innerHTML swap bypasses that — so do it here,
//              otherwise the freshly-rendered item images stay blank. */
//           if (window.theme && typeof theme.manuallyLoadImages === 'function') {
//             theme.manuallyLoadImages(curCartForm);
//           }
//           curCartForm.querySelectorAll('cc-cart-cross-sell').forEach(el => {
//             if (typeof el.init === 'function') el.init();
//           });
//           /* Re-execute inline scripts inside the replaced subtree so threshold observers
//              rebind against the new DOM. innerHTML doesn't run <script> tags by itself. */
//           curCartForm.querySelectorAll('script').forEach(oldScript => {
//             const newScript = document.createElement('script');
//             for (const attr of oldScript.attributes) newScript.setAttribute(attr.name, attr.value);
//             newScript.textContent = oldScript.textContent;
//             oldScript.parentNode.replaceChild(newScript, oldScript);
//           });
//         }
//         if (typeof free_gift_Updates === 'function') {
//           try { free_gift_Updates(); } catch (e) {}
//         }
//       });
//   };

//   /* Wire each threshold-gift add button (gift + second threshold) to the AJAX add-to-cart
//      flow. Reading the variant selector inside the same card the button lives in ensures the
//      correct product is added when the active tier advances from gift → second. */
//  document.body.addEventListener('click', function (e) {
//     const btn = e.target.closest('.ctm_btn.add-to-cart');
//     if (!btn) return;
//     /* Only intercept clicks on the threshold-gift cards (which live inside cart-form). */
//     const cartForm = btn.closest('cart-form');
//     if (!cartForm) return;
//     const card = btn.closest('.cart_free_gift__add_form') || btn.closest('.cart_free_gift');
//     if (!card) return;

//     const freeGiftPrdId = card.querySelector('.cart_free_gift__add_form--var-selector')?.value;
//     if (!freeGiftPrdId) return;

//     e.preventDefault();
//     const sectionId = cartForm.getAttribute('data-section-id');
//     const items = [{ id: freeGiftPrdId, quantity: 1 }];

//     /* Mirror the cart-drawer add-to-cart flow (main.js handleSubmit): spinner via
//        `is-loading`, then the success tick via `is-success` for ~2s before cleanup. The
//        threshold-gift form already carries `js-product-form` and the button uses
//        `name="add"`, so the `.js-product-form [name=add]` spinner/tick CSS in main.css
//        applies as-is. The section refresh replaces this button, so it has to wait until
//        the tick animation has finished — otherwise the success state never renders. */
//     btn.setAttribute('aria-disabled', 'true');
//     btn.classList.add('is-loading');

//     fetch('/cart/add.js', {
//       method: 'POST',
//       headers: { 'Content-Type': 'application/json' },
//       body: JSON.stringify({ items })
//     })
//     .then(response => {
//       if (!response.ok) throw new Error('Failed to add item');
//       return response.json();
//     })
//     .then(data => {
//       if (window.klaviyoTrackAddToCart) window.klaviyoTrackAddToCart(data);
//       if (btn.isConnected) {
//         btn.classList.add('is-success');
//         btn.removeAttribute('aria-disabled');
//       }
//       return new Promise((resolve) => setTimeout(resolve, 2000))
//         .then(() => refreshCartFromSections(sectionId))
//         .then(() => {
//           if (btn.isConnected) {
//             btn.classList.remove('is-loading');
//             btn.classList.remove('is-success');
//           }
//         });
//     })
//     .catch(error => {
//       console.error('Error:', error);
//       if (btn.isConnected) {
//         btn.classList.remove('is-loading');
//         btn.classList.remove('is-success');
//         btn.removeAttribute('aria-disabled');
//       }
//     });
//   });

// }
// //////////////////////////////////////////////////////////////////////


// document.addEventListener("DOMContentLoaded", function () {
//   const filterConn = document.querySelector("filter-container");

//   if (filterConn) {
//     const productBlocks = filterConn.querySelectorAll("product-block");

//     productBlocks.forEach((block) => {
//       block.addEventListener("click", function () {
//         // Wait for the popup to fully render
//         setTimeout(() => {
//           const inputRows = document.querySelectorAll(".product-form .input-row");

//           if (inputRows.length > 0) {
//             const swatchItemsContainer = inputRows[0];

//             const swatchLists = swatchItemsContainer.querySelectorAll(
//               "variant-king-combined-listing .swatches ul.swatch-view"
//             );

//             if (swatchLists.length > 0) {
//               swatchLists.forEach((swatchList) => {
//                 const swatchItems = swatchList.querySelectorAll("li.swatch-view-item");

//                 swatchItems.forEach((swatchItem) => {
//                   const imageWrapper = swatchItem.querySelector(".swatch-custom-image");
//                   // console.log(imageWrapper,"=======================");
                  
//                   if (imageWrapper) {
//                     // Overwrite third-party click logic
//                     imageWrapper.addEventListener("click", function (e) {
//                       e.preventDefault();           // Prevent default browser behavior
//                       e.stopPropagation();          // Stop bubbling up to parents
//                       e.stopImmediatePropagation(); // ⛔ Stop other attached listeners (like the third-party one)
//                       // console.log("Swatch click blocked");
//                     }, true); // Use capture phase to block before 3rd party listener runs
//                   }
//                 });
//               });
//             }
//           }
//         }, 3500); // Delay to wait for popup to fully render
//       });
//     });
//   }
// });


// // =====================


// // ===================== slick slider ==================
// function initSlickSlider() {
//   if ($(window).width() < 768) {
//     $('.slider_enabled').each(function () {
//       if (!$(this).hasClass('slick-initialized')) {
//         $(this).slick({
//           dots: false,
//           arrows: true,
//           infinite: false,
//           speed: 800,
//           slidesToShow: 4,
//           slidesToScroll: 1,
//           responsive: [
//             { 
//               breakpoint: 767,
//               settings: {
//                 slidesToShow: 4,
//                 slidesToScroll: 1
//               }
//             },
//             {
//               breakpoint: 700,
//               settings: {
//                 slidesToShow: 4,
//                 slidesToScroll: 1
//               }
//             },
//             {
//               breakpoint: 520,
//               settings: {
//                 slidesToShow: 4, 
//                 slidesToScroll: 1,
//                 centerMode: false, 
//                 dots: false,
//                 arrows: true
//               }
//             }
//           ]
//         });
//       }
//     });
//   } else {
//     $('.slider_enabled.slick-initialized').slick('unslick');
//   }
// }

// window.addEventListener("facet_filter_change", () => {
//   setTimeout(() => {
//     initSlickSlider();
//   }, 0);
// });

// // Run on document ready
// $(document).ready(function () {
//   initSlickSlider();
// });

// // Run on window resize
// $(window).on('resize', function () {
//   initSlickSlider();
// });

// // Helper: Run this after AJAX content is loaded
// function reInitSliderAfterAjax() {
//   initSlickSlider();
// }

// document.addEventListener("DOMContentLoaded", function () {

//   document.querySelectorAll(".price-row").forEach(function (row) {

//     const priceEl = row.querySelector(".price__current");
//     const labelEl = row.closest(".associated-product")?.querySelector(".custom-product-label");
//     const targetEl = row.querySelector(".per-item_price");

//     if (!priceEl || !targetEl || !labelEl) return;

//     // Get numeric price from .price__current (removes currency symbols)
//     const priceValue = parseFloat(
//       priceEl.textContent.replace(/[^0-9.]/g, "")
//     );

//     // Get numeric bundle/label value
//     const labelValue = parseFloat(
//       labelEl.textContent.replace(/[^0-9.]/g, "")
//     );

//     if (!priceValue || !labelValue || labelValue <= 0) {
//       targetEl.style.display = "none";
//       return;
//     }

//     // Divide price by label number
//     const perItemPrice = (priceValue / labelValue).toFixed(2);

//     // Save to attribute
//     targetEl.setAttribute("price", perItemPrice);

//     // (Optional) show value visually
//     targetEl.textContent = perItemPrice;

//   });

// });


// /* Preserve the currently selected variant options (e.g. Size, Color) when the user
//    clicks a .custom-product-label link that navigates to an associated product
//    (e.g. switching from 1-pack to 2 Packs). The destination is a different product
//    so variant IDs don't translate — instead we forward the option *values* as URL
//    search params keyed by option name (`?Size=XXL&Color=Red`). variant-picker.js
//    already exposes applySearchParams() which re-selects matching radios/dropdowns
//    on load, so the size stays selected after the page reload. */
// document.addEventListener('click', function (e) {
//   const labelEl = e.target.closest('.custom-product-label');
//   if (!labelEl) return;

//   const linkEl = labelEl.closest('a[href]');
//   if (!linkEl) return;

//   const href = linkEl.getAttribute('href');
//   if (!href || href.startsWith('#') || href.startsWith('javascript:')) return;

//   /* Read selected option from the primary variant-picker selectors only. There can
//      be additional Color fieldsets inside .customSwatchesCon (bundle products) that
//      share the same data-option name, so dedupe by name and keep the first match. */
//   const seen = new Set();
//   const params = [];
//   document.querySelectorAll('variant-picker .option-selector[data-option]').forEach((selector) => {
//     const optName = selector.dataset.option;
//     if (!optName || seen.has(optName)) return;

//     let value = null;
//     if (selector.dataset.selectorType === 'dropdown') {
//       const selected = selector.querySelector('.custom-select__option[aria-selected="true"]');
//       value = selected && selected.dataset.value ? selected.dataset.value : null;
//     } else {
//       const checkedInput = selector.querySelector('input:checked');
//       value = checkedInput ? checkedInput.value : null;
//     }

//     if (value) {
//       seen.add(optName);
//       params.push([optName, value]);
//     }
//   });

//   if (!params.length) return;

//   try {
//     const url = new URL(href, window.location.origin);
//     params.forEach(([k, v]) => url.searchParams.set(k, v));
//     /* Drop ?variant=… — variant IDs are per-product, so the value from the current
//        page would be wrong on the destination product and override our option params. */
//     url.searchParams.delete('variant');
//     linkEl.setAttribute('href', url.pathname + url.search + url.hash);
//   } catch (err) {
//     /* If URL parsing fails (e.g. unusual href), leave the original href untouched. */
//   }
// }, true);



// const prdBundleIds = [];
// const prdBundlePrices = [];
// const itsPrdIds = [];
// let presentClickedBtn;
// let isMobile = false;
// // Select the parent element with the class 'prd-bundle-main-container'
// const parentElement = document.querySelector('.prd-bundle-main-container');

// // Find the hidden input elements within the parent container
// const maxBundleLimit = parentElement?.querySelector('input[name="max_bundle_limit"]')?.value;
// const minBundleLimit = parentElement?.querySelector('input[name="min_bundle_limit"]')?.value;
// let variantUnavailable = false;

// function formatBundleMoney(cents, format) {
//   format = format || '${{amount}}';
//   cents = Math.round(Number(cents) || 0);
//   const amount = (cents / 100);
//   const withDecimals = (val, places, thousand, decimal) => {
//     const fixed = Math.abs(val).toFixed(places);
//     const parts = fixed.split('.');
//     parts[0] = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + (thousand || ','));
//     return (val < 0 ? '-' : '') + parts.join(places ? (decimal || '.') : '');
//   };
//   return format
//     .replace(/\{\{\s*amount\s*\}\}/g, withDecimals(amount, 2, ',', '.'))
//     .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, withDecimals(amount, 0, ',', ''))
//     .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withDecimals(amount, 2, '.', ','))
//     .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, withDecimals(amount, 0, '.', ''))
//     .replace(/\{\{\s*amount_with_space_separator\s*\}\}/g, withDecimals(amount, 2, ' ', '.'))
//     .replace(/\{\{\s*amount_no_decimals_with_space_separator\s*\}\}/g, withDecimals(amount, 0, ' ', ''))
//     .replace(/\{\{\s*amount_with_period_and_space_separator\s*\}\}/g, withDecimals(amount, 2, ' ', '.'));
// }

// function updateBundleSummary() {
//   const containers = document.querySelectorAll('.prd-bundle-main-container');
//   if (!containers.length) return;
//   const subtotal = prdBundlePrices.reduce((sum, p) => sum + (Number(p) || 0), 0);
//   containers.forEach(container => {
//     const moneyFormat = container.dataset.moneyFormat || '${{amount}}';
//     const maxQty = parseInt(container.dataset.bundleMax, 10) || parseInt(maxBundleLimit, 10) || 0;
//     const discountPct = parseFloat(container.dataset.bundleDiscount) || 0;
//     const count = prdBundleIds.length;
//     const discountActive = count > 0 && discountPct > 0;
//     const discount = discountActive ? Math.round(subtotal * discountPct / 100) : 0;
//     const total = subtotal - discount;

//     // Step circles — N selected products complete N circles; the next upcoming
//     // step (count + 1) gets the active/current state (green border + green check).
//     const steps = container.querySelectorAll('.prd-bundle-step');
//     steps.forEach(step => {
//       const stepNum = parseInt(step.dataset.step, 10) || 0;
//       step.classList.remove('is-completed', 'is-current', 'is-pending');
//       if (stepNum > 0 && count >= stepNum) step.classList.add('is-completed');
//       // Only highlight the next upcoming step once at least one item is selected.
//       // With nothing selected, every step stays pending so the steps look exactly
//       // like the default (fresh page load) render.
//       else if (stepNum > 0 && count > 0 && stepNum === count + 1) step.classList.add('is-current');
//       else step.classList.add('is-pending');

//       // Completed steps get a small remove (×) icon at the top-left of the circle.
//       // Clicking it unselects the matching bundle item (step N → the Nth selected
//       // item) by triggering that item's existing remove button, so every downstream
//       // behaviour (arrays, placeholders, button states, totals) runs exactly as before.
//       const circle = step.querySelector('.prd-bundle-step__circle');
//       if (circle) {
//         let cross = circle.querySelector('.prd-bundle-step__remove');
//         if (step.classList.contains('is-completed')) {
//           if (!cross) {
//             cross = document.createElement('button');
//             cross.type = 'button';
//             cross.className = 'prd-bundle-step__remove';
//             cross.setAttribute('aria-label', 'Remove this item from the bundle');
//             cross.innerHTML = '&times;';
//             cross.addEventListener('click', (e) => {
//               e.preventDefault();
//               e.stopPropagation();
//               const idx = (parseInt(step.dataset.step, 10) || 0) - 1;
//               // Target the same container the items are added to (see addPrdToBundle),
//               // so the Nth remove button lines up with the Nth selected item.
//               const bundleContainer = document.querySelector('.prd-bundle-container');
//               const removeBtns = bundleContainer
//                 ? bundleContainer.querySelectorAll('.bundle-item .remove-item')
//                 : [];
//               if (idx >= 0 && removeBtns[idx]) removeBtns[idx].click();
//             });
//             circle.appendChild(cross);
//           }
//         } else if (cross) {
//           cross.remove();
//         }
//       }
//     });

//     // Progress line — black up to the last completed step, green from there
//     // to the next upcoming (active) step.
//     const stepsContainer = container.querySelector('.prd-bundle-steps');
//     if (stepsContainer) {
//       let progress = 0;       // fraction of the visible track that's filled (black + green)
//       let completedStop = 0;  // % within the fill bar where black ends and green begins
//       if (maxQty > 1) {
//         progress = Math.min(1, Math.max(0, count / (maxQty - 1)));
//         if (count > 0) {
//           completedStop = (count >= maxQty) ? 100 : ((count - 1) / count) * 100;
//         }
//       } else if (maxQty === 1 && count >= 1) {
//         progress = 1;
//         completedStop = 100;
//       }
//       stepsContainer.style.setProperty('--fill-progress', progress);
//       stepsContainer.style.setProperty('--completed-stop', completedStop + '%');
//     }

//     // Summary: subtotal (compare-at — always visible, strike-through only after 1+ items)
//     const subtotalEl = container.querySelector('.js-bundle-subtotal');
//     if (subtotalEl) {
//       subtotalEl.textContent = formatBundleMoney(subtotal, moneyFormat);
//       subtotalEl.classList.toggle('is-strike', count > 0);
//     }

//     // Savings intro ("You're saving 20%")
//     const introEl = container.querySelector('.js-bundle-savings-intro');
//     if (introEl) {
//       const tpl = container.dataset.textSavingsIntro || "You're saving [percent]%";
//       introEl.textContent = tpl
//         .replace('[percent]', discountPct)
//         .replace('[amount]', formatBundleMoney(discount, moneyFormat));
//     }

//     // Savings amount ("You save $24.00") — always visible; reads $0.00 when nothing selected
//     const savingsAmountEl = container.querySelector('.js-bundle-savings-amount');
//     if (savingsAmountEl) {
//       const tpl = container.dataset.textSavingsAmount || 'You save [amount]';
//       savingsAmountEl.textContent = tpl
//         .replace('[amount]', formatBundleMoney(discount, moneyFormat))
//         .replace('[percent]', discountPct);
//       savingsAmountEl.removeAttribute('hidden');
//     }

//     // Total (big)
//     const totalEl = container.querySelector('.js-bundle-total');
//     if (totalEl) totalEl.textContent = formatBundleMoney(total, moneyFormat);

//     // CTA total
//     const ctaTotalEl = container.querySelector('.js-bundle-cta-total');
//     if (ctaTotalEl) ctaTotalEl.textContent = formatBundleMoney(total, moneyFormat);

//   });
// }



// window.addPrdToBundle = function(prd, title, price, featured_image, bundlePrdId, mobileVariantIdn = null, priceCents = 0) {
//   window.__lastBundlePriceCents = priceCents;
//   // Block add-to-bundle (Quick View + bundle PDP) until Size is selected, matching
//   // the required-size validation on the main product page.
//   const formScope = prd.closest('.product-form');
//   const sizeSelector = formScope?.querySelector('[data-option="Size"], [data-option="size"]');
//   if (sizeSelector && !sizeSelector.querySelector('input:checked')) {
//     const bundleBtnWrap = prd.closest('.bundle-btn');
//     if (bundleBtnWrap) {
//       let warning = bundleBtnWrap.previousElementSibling;
//       if (!warning || !warning.classList.contains('bundle-btn-warning')) {
//         warning = document.createElement('p');
//         warning.className = 'bundle-btn-warning';
//         warning.style.cssText = 'color:#b00020;font-size:0.875rem;font-weight:600;margin:0 0 8px 0;';
//         bundleBtnWrap.parentNode.insertBefore(warning, bundleBtnWrap);
//       }
//       warning.textContent = 'Please select a size before adding to bundle.';
//       if (bundleBtnWrap._warningTimeout) clearTimeout(bundleBtnWrap._warningTimeout);
//       bundleBtnWrap._warningTimeout = setTimeout(() => {
//         warning.remove();
//         bundleBtnWrap._warningTimeout = null;
//       }, 4000);
//     }
//     return;
//   }
  
//   itsPrdIds.push(bundlePrdId);
//   // console.log('itsPrdIds: ', itsPrdIds)
//   if(variantUnavailable) return;

//   const anotherImgPresent = document.querySelector('carousel-slider .slider .slider__item.is-active .product-media img');
//   featured_image = anotherImgPresent.src
  
//   let parent = prd.closest('.product-form');
//   let prd_inv_div = parent.querySelector('.product-inventory');
//   let prd_inv_qty = prd_inv_div.querySelector('.product-inventory__status').dataset.lowQty;
//   prd_inv_qty = parseInt(prd_inv_qty);
//   let isLowInv = !(Array.from(prd_inv_div.attributes).some(i => i.name === 'hidden'));
//   let var_id = prd.closest('buy-buttons').querySelector('form input[name="id"]').value;

//   // console.log({prd_inv_qty,prdBundleIds_12345: prdBundleIds.filter(item => item === var_id).length});

//   if(isLowInv){
//     let count = prdBundleIds.filter(item => item === var_id).length;
//     if(prd_inv_qty == count ){ prd.innerHTML = "Out Of Stock"; prd.setAttribute('disabled',''); return; }
//   }

//   if(prdBundleIds.length > (maxBundleLimit-1)) return;
  
//   if(mobileVariantIdn)presentClickedBtn = prd; isMobile = true
//   // console.log('bundlePrdId: ', bundlePrdId)

//   const bundleContainer = document.querySelector('.prd-bundle-container');
//   const productDiv = document.createElement('div');
//   productDiv.classList.add('bundle-item');

//   const img = document.createElement('img');
//   img.src = featured_image;
//   img.alt = title;
//   img.classList.add('bundle-item-image');
//   productDiv.appendChild(img);

//   const prdId = findIdForBundle(prd, mobileVariantIdn);  

//   const removeBtn = document.createElement('span');
//   removeBtn.classList.add('remove-item');
//   removeBtn.innerText = '×';
//   removeBtn.setAttribute('data-id', prdId);

//   removeBtn.addEventListener('click', () => {
//     const productId = removeBtn.getAttribute('data-id');
//     const productIndex = prdBundleIds.indexOf(productId);
//     if (productIndex > -1) {
//       prdBundleIds.splice(productIndex, 1);
//       itsPrdIds.splice(productIndex, 1);
//       prdBundlePrices.splice(productIndex, 1);
//     }
//     // console.log('itsPrdIds: ', itsPrdIds)
//     productDiv.remove();
//     if (prdBundleIds.length < minBundleLimit) document.querySelectorAll('.prd-bundle-AddToCart').forEach(el => el.classList.add('disabled'));
//     if (mobileVariantIdn) changeBtnText(prd, true);
//     else changeBtnText(document.getElementById(bundlePrdId), true);
//     if (prdBundleIds.length < maxBundleLimit) disableAllBtns(false);

//     // Append placeholder if there are no more products
//     if (prdBundleIds.length < maxBundleLimit) {
//         const placeholderDiv = document.createElement('div');
//         placeholderDiv.classList.add('bundle-item');
//         const placeholderImg = document.createElement('img');
//         placeholderImg.src = "https://cdn.shopify.com/s/files/1/1106/6370/files/placeholder.png?v=1739168958";
//         placeholderImg.alt = "Placeholder image";
//         placeholderImg.classList.add('bundle-placeholder-img');
//         placeholderDiv.appendChild(placeholderImg);
//         bundleContainer.appendChild(placeholderDiv);
//     }
//     updateBundleSummary();
//   });

//   productDiv.appendChild(removeBtn);

//   // Check if a placeholder exists
//   const placeholderImage = bundleContainer.querySelector('.bundle-placeholder-img');

//   if (placeholderImage) {
//       // Insert before placeholder if it exists
//       bundleContainer.insertBefore(productDiv, placeholderImage.closest('.bundle-item'));
//   } else {
//       // If no placeholder, insert at the start of the container
//       bundleContainer.appendChild(productDiv);
//   }

//   // Remove placeholder if product is added
//   if (placeholderImage) { placeholderImage.closest('.bundle-item').remove() }

//   const targetDiv = document.querySelector('.filter-container .filters .filters__inner');
//   const targetDivScroll = document.querySelector('.filter-container .filters');
//   if (targetDiv) {
//       let scrollHeightDiv = targetDivScroll.scrollHeight + bundleContainer.scrollHeight; 
//       setTimeout(()=>{ targetDivScroll.scrollTop = scrollHeightDiv },200)
//       // console.log('adddded',scrollHeightDiv );
//   } // else { console.log("Div not found!"); }
// }


// function findIdForBundle(prd, mobileVariantIdn) {
//     if(!mobileVariantIdn){
//         const productIdInput = document.querySelector('input[name="id"]');
//         if (productIdInput) {
//             thisisId(prd, productIdInput.value);
//         } else {
//             console.error('Product ID input not found!');
//         }
//         return(productIdInput.value);
//     }
//     else{
//         thisisId(prd, mobileVariantIdn);
//         return(mobileVariantIdn);
//     }
// }

// function thisisId(prd, id) {
//     prdBundleIds.push(id);
//     const priceCentsToTrack = parseInt(window.__lastBundlePriceCents, 10) || 0;
//     prdBundlePrices.push(priceCentsToTrack);
//     // console.log('prdBundlesIds: ', prdBundleIds)
//     if(prdBundleIds.length == maxBundleLimit ){
//         disableAllBtns(true);

//     }
//     if (prdBundleIds.length >= minBundleLimit) {
//         document.querySelectorAll('.prd-bundle-AddToCart').forEach(el => el.classList.remove('disabled'));
//     }
//     const parentContainer = prd.closest('.quickbuy-container');
//     if (parentContainer) {
//         const closeButton = parentContainer.querySelector('.close-detail');
//         if (closeButton) {
//             closeButton.click();
//         }
//     }
//     changeBtnText(presentClickedBtn);
//     updateBundleSummary();
// }

// function bundlePopupOpen(btn) {  
//   if(prdBundleIds.length > (maxBundleLimit-1)) return;
//   presentClickedBtn = btn;
//   const parentContainer = btn.closest('.image-cont');
//   const quickbuyButton = parentContainer.querySelector('.quickbuy-toggle');
//   if (quickbuyButton) {
//       quickbuyButton.click();
//   }
// }

// function openQuickView(e, btn, product_id){  
//   e.preventDefault();
//   if(prdBundleIds.length > (maxBundleLimit-1)) return;
//   const parentContainer = btn.closest('.image-cont') || btn.closest('.block-inner-inner');
//   presentClickedBtn = parentContainer.querySelector('.bundle-popup-open p');
//   const quickbuyButton = parentContainer.querySelector('.quickbuy-toggle');
//   if (quickbuyButton) {
//       quickbuyButton.click();
//   }
// }

// function changeBtnText(btn, remove=false){
//     // console.log('changeBtnText btn: ', btn)
//     // if(remove){
//     //     btn.innerText = 'Add To Bundle';
//     //     btn.closest('.bundle-popup-open').classList.remove('disabled');

//     // }
//     // else{
//     //     btn.innerText = 'Added';
//     //     btn.closest('.bundle-popup-open').classList.add('disabled');
//     // }
// }

// function disableAllBtns(disable){
//     if(disable){
//         document.querySelectorAll('.bundle-popup-open p').forEach((singleBtn)=>{
//             singleBtn.style.opacity = '0.5'
//             singleBtn.style.cursor = 'default'
//         })
//     }
//     else{
//         document.querySelectorAll('.bundle-popup-open p').forEach((singleBtn)=>{
//             singleBtn.style.opacity = '1'
//             singleBtn.style.cursor = 'pointer'
//         })
//     }
// }

// // function updateBundleBtn(){
// //   itsPrdIds.forEach((bundlePrdId)=>{
// //     changeBtnText(document.getElementById(bundlePrdId), false);
// //   })
// // }

// function getActiveBundleLimits() {
//   const container = document.querySelector('.prd-bundle-main-container:not([style*="display: none"])')
//                  || document.querySelector('.prd-bundle-main-container');
//   const maxVal = parseInt(container?.dataset?.bundleMax, 10)
//               || parseInt(container?.querySelector('input[name="max_bundle_limit"]')?.value, 10)
//               || parseInt(maxBundleLimit, 10)
//               || 3;
//   const minVal = parseInt(container?.dataset?.bundleMin, 10)
//               || parseInt(container?.querySelector('input[name="min_bundle_limit"]')?.value, 10)
//               || parseInt(minBundleLimit, 10)
//               || 1;
//   return { max: maxVal, min: minVal };
// }

// async function addBundleToCart(btn) {
//   if (!prdBundleIds || !prdBundleIds.length) return;

//   const atcWrapper = btn.closest('.prd-bundle-AddToCart');
//   if (atcWrapper && (atcWrapper.classList.contains('disabled') || atcWrapper.classList.contains('is-loading'))) {
//     return;
//   }

//   const allAtcButtons = document.querySelectorAll('.prd-bundle-AddToCart');
//   allAtcButtons.forEach(el => el.classList.add('is-loading'));

//   const labelEl = btn.querySelector('.prd-bundle-cta__label') || btn;
//   const prevLabelText = labelEl.textContent;
//   labelEl.textContent = 'Adding...';

//   try {
//     const rawDiscountCode = atcWrapper?.dataset?.discountCode;
//     const discount_code = typeof rawDiscountCode === 'string' ? rawDiscountCode.trim() : '';
//     if (discount_code && discount_code !== 'undefined' && discount_code !== 'null' && discount_code !== '') {
//       try {
//         await fetch(`/discount/${encodeURIComponent(discount_code)}`);
//       } catch (discountErr) {
//         console.warn('Discount fetch failed:', discountErr);
//       }
//     }

//     const cartDrawerEl = document.querySelector('.js-cart-drawer') || document.querySelector('cart-drawer');
//     const cartFormEl = cartDrawerEl?.querySelector('cart-form') || document.querySelector('cart-form');
//     const cartDrawerSectionId = cartDrawerEl?.dataset?.sectionId || cartFormEl?.dataset?.sectionId;
//     const headerEl = document.querySelector('page-header') || document.querySelector('.page-header');
//     const headerSectionId = headerEl?.dataset?.sectionId;

//     const sectionIdsToRequest = [cartDrawerSectionId, headerSectionId].filter(Boolean);

//     const payload = {
//       items: prdBundleIds.map(id => ({ id: Number(id) || id, quantity: 1 }))
//     };

//     if (sectionIdsToRequest.length > 0) {
//       payload.sections = sectionIdsToRequest.join(',');
//       payload.sections_url = window.location.pathname;
//     }

//     const response = await fetch('/cart/add.js', {
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/json',
//         'Accept': 'application/json, text/javascript'
//       },
//       body: JSON.stringify(payload)
//     });

//     if (!response.ok) {
//       throw new Error(`Failed to add items to cart (status ${response.status})`);
//     }

//     const data = await response.json();

//     if (data && (data.items || !data.status)) {
//       if (window.klaviyoTrackAddToCart) {
//         try { window.klaviyoTrackAddToCart(data); } catch (e) {}
//       }

//       // Update cart drawer directly using returned section HTML or fallback
//       let drawerHtml = null;
//       if (data.sections && cartDrawerSectionId && data.sections[cartDrawerSectionId]) {
//         drawerHtml = data.sections[cartDrawerSectionId];
//       } else if (data.sections) {
//         const matchingKey = Object.keys(data.sections).find(k => k.includes('cart-drawer'));
//         if (matchingKey) drawerHtml = data.sections[matchingKey];
//       }

//       if (drawerHtml && cartFormEl) {
//         const doc = new DOMParser().parseFromString(drawerHtml, 'text/html');
//         const newCartForm = doc.querySelector('cart-form[data-section-id="' + cartDrawerSectionId + '"]') || doc.querySelector('cart-form');
//         if (newCartForm) {
//           cartFormEl.innerHTML = newCartForm.innerHTML;
//           if (window.theme && typeof theme.manuallyLoadImages === 'function') {
//             theme.manuallyLoadImages(cartFormEl);
//           }
//           cartFormEl.querySelectorAll('cc-cart-cross-sell').forEach(el => {
//             if (typeof el.init === 'function') el.init();
//           });
//           cartFormEl.querySelectorAll('script').forEach(oldScript => {
//             const newScript = document.createElement('script');
//             for (const attr of oldScript.attributes) newScript.setAttribute(attr.name, attr.value);
//             newScript.textContent = oldScript.textContent;
//             oldScript.parentNode.replaceChild(newScript, oldScript);
//           });
//         }
//       } else if (cartDrawerSectionId && typeof refreshCartFromSections === 'function') {
//         await refreshCartFromSections(cartDrawerSectionId);
//       }

//       // Update header cart count / icon
//       let headerHtml = null;
//       if (data.sections && headerSectionId && data.sections[headerSectionId]) {
//         headerHtml = data.sections[headerSectionId];
//       } else if (data.sections) {
//         const matchingKey = Object.keys(data.sections).find(k => k.includes('header'));
//         if (matchingKey) headerHtml = data.sections[matchingKey];
//       }
//       if (headerHtml) {
//         const headerDoc = new DOMParser().parseFromString(headerHtml, 'text/html');
//         const newCartLink = headerDoc.querySelector('.cart-link');
//         const curCartLink = document.querySelector('.cart-link');
//         if (newCartLink && curCartLink) {
//           curCartLink.innerHTML = newCartLink.innerHTML;
//         }
//       }

//       if (typeof free_gift_Updates === 'function') {
//         try { free_gift_Updates(); } catch (e) {}
//       }

//       // Open the drawer
//       if (cartDrawerEl && typeof cartDrawerEl.open === 'function') {
//         cartDrawerEl.open();
//       } else {
//         document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open', { bubbles: true }));
//       }
//     }
//   } catch (error) {
//     console.error('Error adding bundle to cart:', error);
//   } finally {
//     if (labelEl) {
//       labelEl.textContent = prevLabelText;
//     }
//     allAtcButtons.forEach(el => el.classList.remove('is-loading'));
//   }
// }

// window.addBundleToCart = addBundleToCart;



// document.addEventListener('DOMContentLoaded', function() {
//   const element = document.querySelector('.filter-container.filter-container--side.bundle-collection');
//   const mobileContainer = document.querySelector('.prd-bundle-main-container.for_mobile');
//   const desktopHeading = document.querySelector('.filter-group__heading__text.for_desktop');
//   const desktopContainer = document.querySelector('.prd-bundle-main-container.for_desktop');
  
//   // Show the filter group items
//   document.querySelectorAll('.filter-group__heading').forEach(item => item.style.pointerEvents = 'none' );

//   document.querySelectorAll('.filter-group__heading.toggle-target-toggler--is-hidden').forEach(item => item.classList.remove('toggle-target-toggler--is-hidden'));
//   document.querySelector('.filter-group__items.filter-group--3.toggle-target.toggle-target--hidden')?.classList.remove('toggle-target--hidden');

//   // Corrected the variable names in the console log
//   // console.log('mobileContainer: ', mobileContainer, ' desktopHeading: ', desktopHeading, ' desktopContainer: ', desktopContainer);

//   // Handle display based on screen size
//   if (window.innerWidth <= 999) {
//     element?.classList.replace('filter-container--show-filters-desktop', 'filter-container--show-filters-mobile');
//     if (mobileContainer) { mobileContainer.style.display = 'block'}
//     if (desktopHeading) { desktopHeading.remove() }
//     if (desktopContainer) { desktopContainer.remove() }

//     const mobileFiltersWrap = document.querySelector('.filter-container .filters.mobile-sticky-maincontainer');
//     const desktopFiltersWrap = document.querySelector('.filter-container .filters:not(.mobile-sticky-maincontainer)');
//     if (mobileFiltersWrap && desktopFiltersWrap) {
//       mobileFiltersWrap.addEventListener('change', (evt) => {
//         const src = evt.target;
//         if (!src || !src.matches || !src.matches('input, select, textarea')) return;
//         const escName = CSS.escape(src.name);
//         if (src.type === 'radio') {
//           desktopFiltersWrap.querySelectorAll(`input[type="radio"][name="${escName}"]`).forEach((el) => {
//             el.checked = (el.value === src.value);
//           });
//         } else if (src.type === 'checkbox') {
//           const dst = desktopFiltersWrap.querySelector(`input[type="checkbox"][name="${escName}"][value="${CSS.escape(src.value)}"]`);
//           if (dst) dst.checked = src.checked;
//         } else {
//           const dst = desktopFiltersWrap.querySelector(`[name="${escName}"]`);
//           if (dst) dst.value = src.value;
//         }
//       });
//     }
//   } else {
//     element?.classList.replace('filter-container--show-filters-mobile', 'filter-container--show-filters-desktop');
//     if (desktopHeading) { desktopHeading.style.display = 'block' }
//     if (desktopContainer) { desktopContainer.style.display = 'block' }
//     if (mobileContainer) { mobileContainer.remove() }
//   }
// });


// /* 

// console.log('working custom-mw.js');

// const prdBundleIds = [];
// let presentClickedBtn;
// // Select the parent element with the class 'prd-bundle-main-container'
// const parentElement = document.querySelector('.prd-bundle-main-container');

// // Find the hidden input elements within the parent container
// const maxBundleLimit = parentElement.querySelector('input[name="max_bundle_limit"]').value;
// const minBundleLimit = parentElement.querySelector('input[name="min_bundle_limit"]').value;

// // Log the values to the console (you can also use these values in your code)
// console.log('Max Bundle Limit:', maxBundleLimit);
// console.log('Min Bundle Limit:', minBundleLimit);


// function addPrdToBundle(prd, title, price, featured_image, bundlePrdId) {
//     console.log('bundlePrdId: ', bundlePrdId)
//     const bundleContainer = document.querySelector('.prd-bundle-container');
//     const productDiv = document.createElement('div');
//     productDiv.classList.add('bundle-item');

//     const img = document.createElement('img');
//     img.src = featured_image;
//     img.alt = title;
//     img.classList.add('bundle-item-image');
//     productDiv.appendChild(img);

//     const prdId = findIdForBundle(prd);

//     const removeBtn = document.createElement('span');
//     removeBtn.classList.add('remove-item');
//     removeBtn.innerText = '×';

//     removeBtn.setAttribute('data-id', prdId);

//     removeBtn.addEventListener('click', () => {
//         const productId = removeBtn.getAttribute('data-id');
//         const productIndex = prdBundleIds.indexOf(productId);
//         if (productIndex > -1) prdBundleIds.splice(productIndex, 1);
//         console.log('prdBundleIds after: ', prdBundleIds)
//         productDiv.remove();
//         if (prdBundleIds.length < minBundleLimit ) document.querySelector('.prd-bundle-AddToCart').classList.add('disabled');
//         changeBtnText( document.getElementById(bundlePrdId) , true);
//         if(prdBundleIds.length < maxBundleLimit ) disableAllBtns(false);
//     });

//     productDiv.appendChild(removeBtn);
//     bundleContainer.appendChild(productDiv);
// }


// function findIdForBundle(prd) {
//     const productIdInput = document.querySelector('input[name="id"]');
//     if (productIdInput) {
//         thisisId(prd, productIdInput.value);
//     } else {
//         console.error('Product ID input not found!');
//     }
//     return(productIdInput.value);
// }

// function thisisId(prd, id) {
//     prdBundleIds.push(id);
//     console.log('prdBundlesIds: ', prdBundleIds)
//     if(prdBundleIds.length == maxBundleLimit ){
//         disableAllBtns(true);
       
//     }
//     if (prdBundleIds.length >= minBundleLimit) {
//         document.querySelector('.prd-bundle-AddToCart').classList.remove('disabled');
//     }
//     const parentContainer = prd.closest('.quickbuy-container');
//     if (parentContainer) {
//         const closeButton = parentContainer.querySelector('.close-detail');
//         if (closeButton) {
//             closeButton.click();
//         }
//     }
//     changeBtnText(presentClickedBtn);
// }

// function bundlePopupOpen(btn) {    
//     if(prdBundleIds.length > (maxBundleLimit-1)) return;
//     presentClickedBtn = btn;
//     const parentContainer = btn.closest('.image-cont');
//     const quickbuyButton = parentContainer.querySelector('.quickbuy-toggle');
//     if (quickbuyButton) {
//         quickbuyButton.click();
//     }
// }

// function changeBtnText(btn, remove=false){
//     console.log('changeBtnText btn: ', btn)
//     if(remove){
//         btn.innerText = 'Add To Bundle';
//         btn.closest('.bundle-popup-open').classList.remove('disabled');

//     }
//     else{
//         btn.innerText = 'Added';
//         btn.closest('.bundle-popup-open').classList.add('disabled');
//     }
// }

// function disableAllBtns(disable){
//     if(disable){
//         document.querySelectorAll('.bundle-popup-open p').forEach((singleBtn)=>{
//             singleBtn.style.opacity = '0.5'
//             singleBtn.style.cursor = 'default'
//         })
//     }
//     else{
//         document.querySelectorAll('.bundle-popup-open p').forEach((singleBtn)=>{
//             singleBtn.style.opacity = '1'
//             singleBtn.style.cursor = 'pointer'
//         })
//     }
// }

// async function addBundleToCart(btn) {
//     btn.innerText = 'Loading..'
//     const formData = {
//         items: prdBundleIds.map(id => ({ id, quantity: 1 }))
//     };
//     try {
//         const response = await fetch('/cart/add.js', {
//             method: 'POST',
//             headers: { 'Content-Type': 'application/json' },
//             body: JSON.stringify(formData)
//         });
//         const data = await response.json();
//         if (data && data.items) {
//             window.location.href = '/cart';
//             // const drawer = document.querySelector('.drawer');
//             // if (!drawer.classList.contains('active')) {
//             //     drawer.classList.remove("is-empty");
//             //     drawer.classList.add("active");
//             //     drawer.setAttribute('open', 'true');
//             //     document.body.classList.add('overflow-hidden');
//             // }
//             // $('.drawer').load(location.href + ' .cart-drawer');
//             // $('.cart-link__icon').load(location.href + ' .cart-link__icon');
//         }
//     } catch (error) {
//         console.error('Error: ', error);
//     }
// }

// */



// // -----------------------------------------
  
// let finalSelectedVariants = [];
// const discountPer = (100 - document.querySelector('[color_discount]')?.getAttribute('color_discount')) / 100 || null;

// function colorsInputChangeHandler(inpElm, optName, optionSelectedValue) {
  
//   // variantUnavailable = inpElm.classList.contains('is-unavailable');
//   setTimeout(() => {
//     let get_all_checked_inputs = inpElm?.closest('variant-picker').querySelectorAll('input:checked');
//     variantUnavailable =  Array?.from(get_all_checked_inputs)?.some( i => i.classList.contains('is-unavailable'))
  
//     let bundle_btn = inpElm.closest('.product-form').querySelector('.bundle-btn .add-to-bundle');
//     if(variantUnavailable){ bundle_btn.innerHTML = 'Out Of Stock'; bundle_btn.setAttribute('disabled','') }
//     else{ bundle_btn.innerHTML = 'Add To Bundle'; bundle_btn.removeAttribute('disabled','') }
//   }, 100);

//   // console.log('prdBundleIds colorsInputChangeHandler',prdBundleIds);
  


//   const colorBundle = document.querySelector('.color_bundle');
//   if(!colorBundle){ return } 

//   const variantScript = document.querySelector('variant-picker script');
//   const variantsData = JSON.parse(variantScript.textContent);
    
//   if (optionSelectedValue) {
//     const optionSelector = inpElm.closest('.customSwatchesCon');
//     const spanHeadingColor = optionSelector.querySelector('.option-selector__label-value');
//     spanHeadingColor.innerText = inpElm.value;
//   }

//   const checkedInputSize = document.querySelector('fieldset[data-option="Size"] input:checked');
//   const allCheckedInputColor = document.querySelectorAll('fieldset[data-option="Color"] input:checked');
//   let selectedOptions = [];

//   if (!inpElm) {
//     handleUnavailableVariants(checkedInputSize);
//     return;
//   }

//   if (optName === 'Color') {
//     handleColorSelection(inpElm, checkedInputSize);
//   } else if (allCheckedInputColor?.length > 0) {
//     allCheckedInputColor.forEach(checkedInputColor => handleVariantSelection(inpElm, checkedInputSize, checkedInputColor));
//   }

//   updateAddToCartButton();

//   function handleColorSelection(inpElm, checkedInputSize) {
//     selectedOptions = [checkedInputSize.value, inpElm.value];
//     const selectedVariant = findSelectedVariant(selectedOptions);
//     updateSelectedOptions(inpElm.name, selectedVariant?.id, selectedVariant.featured_image, selectedVariant.featured_media.id, selectedVariant.price, selectedVariant?.compare_at_price);

//     if (!selectedVariant?.available) {
//       removeUnavailableVariant(selectedVariant);
//     }
//   }

//   function handleVariantSelection(inpElm, checkedInputSize, checkedInputColor) {
//     selectedOptions = [inpElm.value, checkedInputColor.value];
//     const selectedVariant = findSelectedVariant(selectedOptions);

//     updateSelectedOptions(checkedInputColor.name, selectedVariant?.id, selectedVariant.featured_image, selectedVariant.featured_media.id, selectedVariant.price, selectedVariant?.compare_at_price);
//     resetUnavailableClasses();

//     const unavailableVariants = findUnavailableVariants(checkedInputSize.value);
//     if (unavailableVariants?.length > 0) {
//       markUnavailableVariants(unavailableVariants);
//     }
//   }

//   function findSelectedVariant(options) {
//     return variantsData.variants.find(v => v.options.every((val, index) => val === options[index]));
//   }

//   function updateSelectedOptions(name, value, featureImgSrc, featuredMediaId, variantPrice, compareAtPrice = null) {

//   // console.log(selectedOptions,'selected options here');
  
  
//     const sideImagesWrapper = document.querySelector('.side-images-wrapper');
    
//     // Check if the side-images-container already exists by looking for the specific id
//     let sideImageContainer = document.getElementById(`side-img-${name}`);

//     const firstMainImage = document.querySelector(`.product-media-collage [data-media-id="${featuredMediaId}"]`);
//     const mainImage = firstMainImage?.querySelector(`img`);
//     document.querySelector('[imgActive]')?.removeAttribute('imgActive');

//   if(sideImageContainer){
//     const imgElement = sideImageContainer.querySelector('img');
//     const mediaId = sideImageContainer.getAttribute('featured-media-id');

//       if (imgElement) {
//           imgElement.src = featureImgSrc.src;
//           imgElement.alt = featureImgSrc.alt;
//           // imgElement.removeAttribute('featured-media-id');
//           sideImageContainer.setAttribute('featured-media-id', featuredMediaId);
//           sideImageContainer.setAttribute('imgActive', '');
          
//           sideImageContainer.setAttribute('options-atr', `${selectedOptions[0]}-----${selectedOptions[1]}`);
          

//       }
//       }else{
//         sideImageContainer = document.createElement('div');
//         sideImageContainer.classList.add('side-images-container');
//         sideImageContainer.id = `side-img-${name}`;
//         sideImageContainer.setAttribute('featured-media-id', featuredMediaId);
//         sideImageContainer.setAttribute('imgActive', '');
//         sideImageContainer.setAttribute('options-atr', `${selectedOptions[0]}-----${selectedOptions[1]}`);
//         sideImageContainer.addEventListener('click',()=>{
//           sideImagesMediaChange(`side-img-${name}`);
//         })

//         // Create the image element
//         const imgElement = document.createElement('img');
//         imgElement.classList.add('slider-image');
//         imgElement.src = featureImgSrc.src;
//         imgElement.alt = featureImgSrc.alt;

//         // Append the image element to the container
//         sideImageContainer.appendChild(imgElement);

//         // Append the new container to the side-images-wrapper
//         sideImagesWrapper.appendChild(sideImageContainer);
  
//   }

//     const existingOptionIndex = finalSelectedVariants.findIndex(option => option[name] !== undefined);
//     if (existingOptionIndex !== -1) {
//       finalSelectedVariants[existingOptionIndex][name] = value;
//       finalSelectedVariants[existingOptionIndex].price = variantPrice;
//       finalSelectedVariants[existingOptionIndex].compareAtPrice = compareAtPrice;
//       finalSelectedVariants[existingOptionIndex].featuredMediaId = featuredMediaId;

//     } else {
//       finalSelectedVariants.push({ [name]: value, price: variantPrice, compareAtPrice: compareAtPrice, featuredMediaId:featuredMediaId });
//     }

//   }

//   function handleUnavailableVariants(checkedInputSize) {
//     if (allCheckedInputColor?.length > 0) {
//       allCheckedInputColor.forEach(checkedInputColor => {        
//         selectedOptions = [checkedInputSize.value, checkedInputColor.value];
//         const selectedVariant = findSelectedVariant(selectedOptions);
//         updateSelectedOptions(checkedInputColor.name, selectedVariant?.id, selectedVariant.featured_image, selectedVariant.featured_media.id, selectedVariant.price, selectedVariant?.compare_at_price);
//       });
//     }

//     resetUnavailableClasses();
//     const unavailableVariants = findUnavailableVariants(checkedInputSize.value);
//     if (unavailableVariants?.length > 0) {
//       markUnavailableVariants(unavailableVariants);
//     }
//   }

//   function resetUnavailableClasses() {
//     document.querySelectorAll('.customSwatchesCon input[type="radio"].is-unavailable')
//       .forEach(elm => elm.classList.remove('is-unavailable'));

//        document.querySelectorAll('variant-picker input[type="radio"].is-unavailable')
//       .forEach(elm => elm.classList.remove('is-unavailable'));
//   }

//   function findUnavailableVariants(sizeValue) {
//     return variantsData.variants.filter(v => v.option1 === sizeValue && !v.available);
//   }

//   function markUnavailableVariants(unavailableVariants) {
//     unavailableVariants.forEach(unavailableItem => {
//       document.querySelectorAll(`.customSwatchesCon input[value='${unavailableItem.option2}']`)
//         .forEach(elm => elm.classList.add('is-unavailable'));

//          document.querySelectorAll(`variant-picker input[value='${unavailableItem.option2}']`)
//         .forEach(elm => elm.classList.add('is-unavailable'));
//       removeUnavailableVariant(unavailableItem);
//     });
//   }

//   function removeUnavailableVariant(variant) {
//     finalSelectedVariants = finalSelectedVariants.filter(obj => !Object.values(obj).some(value => value === variant.id));
//   }

//   function updateAddToCartButton() {
//     const customAddToCartBtn = document.querySelector('.custom-add-to-cart-btn');
//     if (customAddToCartBtn) {
//       if (finalSelectedVariants.length > 0) {
//         customAddToCartBtn.innerText = "Add To Cart";
//         customAddToCartBtn.removeAttribute('disabled');
//       } else {
//         customAddToCartBtn.setAttribute('disabled', true);
//         customAddToCartBtn.innerText = "Sold Out";
//       }
//     }
//   }

//   // console.log('hi lovovovdsjojd');
//   if (optName === 'Size') {
//     document.querySelector('[imgactive]')?.removeAttribute('imgactive');
//     const sideImagesContainer = document.querySelectorAll('.side-images-container');
//     if(sideImagesContainer?.length > 0){
//       sideImagesContainer.forEach((itm,i)=>{
//         if(i==0){
//           itm.setAttribute('imgactive', '');
//         }
//       })
//     }
//   }
  
//   const activeMediaObj = document.querySelector('.custom-media-gall-cls media-gallery');
//   // console.log(activeMediaObj,'media gg');

//   // if(activeMediaObj){ activeMediaObj.style.pointerEvents = 'none' }
//   const boundOnVariantChange = activeMediaObj.onVariantChange.bind(activeMediaObj);

//   // Calling the method manually
//   boundOnVariantChange({
//       type: 'on:variant:change',   // Event type (optional)
//       detail: { selectedOptions: selectedOptions },  // Event data
//   });


//   if(finalSelectedVariants.length > 1){
//     const sideImagesWrapper = document.querySelector('.side-images-wrapper');
//     if(sideImagesWrapper){ sideImagesWrapper.classList.remove('hidden') }

//     const customAddToCartBtn2 = document.querySelector('.custom-add-to-cart-btn');
//     const allInputColorSelectors = document.querySelectorAll('fieldset[data-option="Color"] .option-selector__btns');
//     if(allInputColorSelectors?.length == finalSelectedVariants?.length){ customAddToCartBtn2.style.opacity = 1 }
//   }
// }

// document.addEventListener('DOMContentLoaded', function () {
//   const colorBundle = document.querySelector('.color_bundle');
//   if(colorBundle){
//     // console.log('color bundle class found');
    
//     colorsInputChangeHandler();
//   }
// });


// function addToCartBundleVariants(e,btnElm){    
//   e.preventDefault();


//   const allInputColorSelectors = document.querySelectorAll('fieldset[data-option="Color"] .option-selector__btns');
//   const qtySubmitRow = btnElm.closest('.quantity-submit-row__submit');

//   if(allInputColorSelectors?.length !== finalSelectedVariants?.length){
//     const customVariantSelectionMsg = qtySubmitRow.querySelector('.custom-variant-selection-msg');
//     if(customVariantSelectionMsg){
//       // customVariantSelectionMsg.classList.remove('hidden');
//       customVariantSelectionMsg.style.visibility = 'initial'
//       customVariantSelectionMsg.style.height = 'auto'
//     }
//     setTimeout(()=>{
//       // customVariantSelectionMsg.classList.add('hidden');
//       customVariantSelectionMsg.style.visibility = 'hidden'
//       customVariantSelectionMsg.style.height = '0'
//     },3000)
//     return;
//   }
  
//   const allCheckedCus = document.querySelectorAll('.customSwatchesCon input:checked');

// // if(finalSelectedVariants.length <= 0){
// //   return;
// // }

// const items = finalSelectedVariants?.map(itm=>({ 'id': Object.values(itm)[0], 'quantity' : 1, properties: {_color_bundle: 'bundle'} }))
// // console.log(items, 'items here');

// // return

//   try {
//     // btnElm.closest('.quantity-submit-row__submit')?.classList.add('js-product-form');
//   btnElm.setAttribute('aria-disabled', 'true');
//   btnElm.classList.add('is-loading');

//     let formData = {
//     'items': items
//     };

//     fetch('/cart/add.js', {
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/json'
//       },
//       body: JSON.stringify(formData)
//     })
//     .then(response => {
//       return response.json();
//     }).then(res=>{
//       if (window.klaviyoTrackAddToCart) window.klaviyoTrackAddToCart(res);

//       // const cartDrawer = document.querySelector('cart-drawer');
//       // if(cartDrawer){
//       //   cartDrawer.cartRefreshHandler();
//       //   cartDrawer.open();
//       // }
//       btnElm.classList.add('is-success');
//         btnElm.removeAttribute('aria-disabled');


//         setTimeout(() => {
//           if(allCheckedCus.length > 0){
//             allCheckedCus.forEach((elm)=>{
//               elm.checked = false;
//             })
//           }
//           btnElm.classList.remove('is-loading');
//           btnElm.classList.remove('is-success');
//           window.location.href = '/cart';
//         }, 2000);
//         })
//     .catch((error) => {
//       console.error('Error:', error);
//     });
//   } catch (error) {
//     console.log(error,'err here');

//   }
// }

// function stickyAtcCusButtonHanlder(e){
//   e.preventDefault();
//   const customAddToCartBtn = document.querySelector('.custom-add-to-cart-btn');
//   if(customAddToCartBtn){
//     window.scrollTo(0, 100);
//     customAddToCartBtn.click();
//   }
// }

// function sideImagesMediaChange(id){
  
//   const sideImagesContainer = document.getElementById(id);
//   // console.log(sideImagesContainer, 'sideImagesContainer');
//   if(sideImagesContainer){
//     const curOptions = sideImagesContainer.getAttribute('options-atr');
//     const selectedOpts = curOptions.split("-----");


//     document.querySelector('[imgactive]')?.removeAttribute('imgactive');
//     //   document.querySelectorAll('.no-hidden')?.forEach(img => img.classList.replace('no-hidden', 'hidden'))
//     //   handlePrdImage(document.querySelector(`.product-media-collage [data-media-id="${featuredMediaId}"]`))
//     // }
//     const activeMediaObj2 = document.querySelector('.custom-media-gall-cls media-gallery');
    
//     const boundOnVariantChange = activeMediaObj2.onVariantChange.bind(activeMediaObj2);
    
//     // Calling the method manually
//     boundOnVariantChange({
//       type: 'on:variant:change',   // Event type (optional)
//       detail: { selectedOptions: selectedOpts },  // Event data
//     });

//     sideImagesContainer.setAttribute('imgactive', '');

//   }

// }




// const targetElements = document.querySelectorAll("cart-form");
// let mutationTimeout;

// const free_gift_mutation = (mutationsList) => {
//     clearTimeout(mutationTimeout);
//     mutationTimeout = setTimeout(() => { free_gift_Updates() }, 500);
// };

// //////
// // function removeHashFromUrl(url) { return url.replace(/:(\w+)(?=&|$)/, '') }
// // function removeFreeGift(id){
// //   let item = document.querySelector(`cart-form .cart-item-list .cart-item[data-product-id="${id}"]`);
// //   let qty_div = item.querySelector('.cart-item__quantity .quantity');
// //   let qty_inp = qty_div.querySelector('input');
// //   let dec_btn = qty_div.querySelector('#updates_dec_1');
// //   qty_inp.value = 1;
// //   dec_btn.click();
// // }
// ////

// // const free_gift_Updates = () => {
// //     // console.log("Cart drawer changed! Running necessary updates...");

// //     let free_gift_parent = document.getElementById('cart_free_gift--wrapper');
// //     let free_gift_progress = free_gift_parent.querySelector('[data-free-shipping-progress]')?.getAttribute('data-free-shipping-progress');
// //     let free_gift_prd_id = free_gift_parent.getAttribute('data-free-gift-id'); 
// //     let cart_drawer_list = document.querySelectorAll('cart-form .cart-item-list .cart-item');

// //     let free_gift_add_form = free_gift_parent.querySelector('.cart_free_gift__add_form product-form');
// //     let free_gift_locked = free_gift_parent.querySelector('.ctm_btn--locked');
// //     let cart_item_ids = Array.from(cart_drawer_list).map(e => e.getAttribute('data-product-id'));

// //     let count = cart_item_ids.filter(id => id === free_gift_prd_id).length; ////////////    

// //     if(cart_drawer_list.length > 0){ free_gift_parent.classList.remove('cart-drawer__footer--hidden') }
// //     else{ free_gift_parent.classList.contains('cart-drawer__footer--hidden') ? '' : free_gift_parent.classList.add('cart-drawer__footer--hidden') ; }

// //     if(!cart_item_ids.includes(free_gift_prd_id)){
// //       if(free_gift_progress != '1'){
// //         free_gift_add_form.style.display = 'none';
// //         free_gift_locked.style.display = 'block';
// //       }else{
// //         free_gift_add_form.style.display = 'block';
// //         free_gift_locked.style.display = 'none';
// //       }
// //     }else{

// //       // if(free_gift_progress != '1'){ removeFreeGift(free_gift_prd_id) } //////////////
// //       // else if(count > 1){ removeFreeGift(free_gift_prd_id) } /////////////

// //       free_gift_add_form.style.display = 'none';
// //       free_gift_locked.style.display = 'block';
// //     }
// // };

// const free_gift_Updates = () => {
//     // console.log("Cart drawer changed! Running necessary updates...");

//     let cart_drawer_list = document.querySelectorAll('cart-form .cart-item-list .cart-item');
//     let cart_item_ids = Array.from(cart_drawer_list).map(e => e.getAttribute('data-product-id'));

//     /* Toggle the form / locked button on a single threshold-gift wrapper. Reused for both
//        the 2nd-threshold (#cart_free_gift--wrapper) and 3rd-threshold
//        (#cart_second_threshold_gift--wrapper) cards so each one's quantity selector hides
//        once its product is added and reappears when the product is removed. */
//     const updateGiftWrapper = (wrapperId, idAttr) => {
//       const parent = document.getElementById(wrapperId);
//       if (!parent) return;

//       const prd_id = parent.getAttribute(idAttr);
//       const add_form = parent.querySelector('.cart_free_gift__add_form product-form');
//       const locked   = parent.querySelector('.ctm_btn--locked');
//       const giftCard = parent.querySelector('.cart_free_gift');
//       if (!prd_id || !add_form || !locked) return;

//       if (cart_drawer_list.length > 0) {
//         parent.classList.remove('cart-drawer__footer--hidden');
//       } else if (!parent.classList.contains('cart-drawer__footer--hidden')) {
//         parent.classList.add('cart-drawer__footer--hidden');
//       }

//       const progressEl = parent.querySelector('[data-free-shipping-progress]');
//       const progress = progressEl ? progressEl.getAttribute('data-free-shipping-progress') : '1';

//       if (!cart_item_ids.includes(prd_id)) {
//         if (giftCard) giftCard.style.display = '';
//         if (progress != '1') {
//           add_form.style.display = 'none';
//           locked.style.display = 'block';
//         } else {
//           add_form.style.display = 'block';
//           locked.style.display = 'none';
//         }
//       } else {
//         if (giftCard) giftCard.style.display = 'none';
//       }
//     };

//     updateGiftWrapper('cart_free_gift--wrapper', 'data-free-gift-id');
//     updateGiftWrapper('cart_second_threshold_gift--wrapper', 'data-second-threshold-id');
// };

// const observer = new MutationObserver(free_gift_mutation);
// const config = { childList: true, attributes: true, characterData: true, subtree: true };
// targetElements.forEach(element => observer.observe(element, config));

// //////////////////////////////////////////////////////////////////////
// {
// //   document.querySelector('.ctm_btn.add-to-cart')?.addEventListener('click', function () {
// //     // console.log('clicked');
// //     const freeGiftPrdId = document.querySelector('.cart_free_gift__add_form--var-selector')?.value;
// //     if (!freeGiftPrdId) return;

// //     const items = [{
// //       id: freeGiftPrdId,
// //       quantity: 1
// //     }];

// //     try {
// //       const formData = { items };
// //       fetch('/cart/add.js', {
// //         method: 'POST',
// //         headers: { 'Content-Type': 'application/json' },
// //         body: JSON.stringify(formData)
// //       })
// //       .then(response => {
// //         if (response.ok) {
// //           location.reload();
// //         } else {
// //           throw new Error('Failed to add item');
// //         }
// //       })
// //       .catch(error => console.error('Error:', error));
// //     } catch (error) {
// //       console.error('Error:', error);
// //     }
// //   });
  
// // }

// /* Refresh the cart-form via Section Rendering API instead of doing a full page reload —
//      keeps observers, scroll position, and other client state intact while the threshold
//      bars/cards/items re-render with up-to-date server state. */
//   const refreshCartFromSections = (sectionId) => {
//     if (!sectionId) return Promise.resolve();
//     return fetch('/?sections=' + encodeURIComponent(sectionId), { credentials: 'same-origin' })
//       .then(r => r.json())
//       .then(data => {
//         const html = data[sectionId];
//         if (!html) return;
//         const doc = new DOMParser().parseFromString(html, 'text/html');
//         const newCartForm = doc.querySelector('cart-form[data-section-id="' + sectionId + '"]') || doc.querySelector('cart-form');
//         const curCartForm = document.querySelector('cart-form[data-section-id="' + sectionId + '"]') || document.querySelector('cart-form');
//         if (newCartForm && curCartForm) {
//           curCartForm.innerHTML = newCartForm.innerHTML;
//           /* Drawer cart items (and cross-sell blocks) render with loading="manual", i.e.
//              data-manual-src instead of src. The merge path activates these on
//              'on:cart:after-merge', but this innerHTML swap bypasses that — so do it here,
//              otherwise the freshly-rendered item images stay blank. */
//           if (window.theme && typeof theme.manuallyLoadImages === 'function') {
//             theme.manuallyLoadImages(curCartForm);
//           }
//           curCartForm.querySelectorAll('cc-cart-cross-sell').forEach(el => {
//             if (typeof el.init === 'function') el.init();
//           });
//           /* Re-execute inline scripts inside the replaced subtree so threshold observers
//              rebind against the new DOM. innerHTML doesn't run <script> tags by itself. */
//           curCartForm.querySelectorAll('script').forEach(oldScript => {
//             const newScript = document.createElement('script');
//             for (const attr of oldScript.attributes) newScript.setAttribute(attr.name, attr.value);
//             newScript.textContent = oldScript.textContent;
//             oldScript.parentNode.replaceChild(newScript, oldScript);
//           });
//         }
//         if (typeof free_gift_Updates === 'function') {
//           try { free_gift_Updates(); } catch (e) {}
//         }
//       });
//   };

//   /* Wire each threshold-gift add button (gift + second threshold) to the AJAX add-to-cart
//      flow. Reading the variant selector inside the same card the button lives in ensures the
//      correct product is added when the active tier advances from gift → second. */
//  document.body.addEventListener('click', function (e) {
//     const btn = e.target.closest('.ctm_btn.add-to-cart');
//     if (!btn) return;
//     /* Only intercept clicks on the threshold-gift cards (which live inside cart-form). */
//     const cartForm = btn.closest('cart-form');
//     if (!cartForm) return;
//     const card = btn.closest('.cart_free_gift__add_form') || btn.closest('.cart_free_gift');
//     if (!card) return;

//     const freeGiftPrdId = card.querySelector('.cart_free_gift__add_form--var-selector')?.value;
//     if (!freeGiftPrdId) return;

//     e.preventDefault();
//     const sectionId = cartForm.getAttribute('data-section-id');
//     const items = [{ id: freeGiftPrdId, quantity: 1 }];

//     /* Mirror the cart-drawer add-to-cart flow (main.js handleSubmit): spinner via
//        `is-loading`, then the success tick via `is-success` for ~2s before cleanup. The
//        threshold-gift form already carries `js-product-form` and the button uses
//        `name="add"`, so the `.js-product-form [name=add]` spinner/tick CSS in main.css
//        applies as-is. The section refresh replaces this button, so it has to wait until
//        the tick animation has finished — otherwise the success state never renders. */
//     btn.setAttribute('aria-disabled', 'true');
//     btn.classList.add('is-loading');

//     fetch('/cart/add.js', {
//       method: 'POST',
//       headers: { 'Content-Type': 'application/json' },
//       body: JSON.stringify({ items })
//     })
//     .then(response => {
//       if (!response.ok) throw new Error('Failed to add item');
//       return response.json();
//     })
//     .then(data => {
//       if (window.klaviyoTrackAddToCart) window.klaviyoTrackAddToCart(data);
//       if (btn.isConnected) {
//         btn.classList.add('is-success');
//         btn.removeAttribute('aria-disabled');
//       }
//       return new Promise((resolve) => setTimeout(resolve, 2000))
//         .then(() => refreshCartFromSections(sectionId))
//         .then(() => {
//           if (btn.isConnected) {
//             btn.classList.remove('is-loading');
//             btn.classList.remove('is-success');
//           }
//         });
//     })
//     .catch(error => {
//       console.error('Error:', error);
//       if (btn.isConnected) {
//         btn.classList.remove('is-loading');
//         btn.classList.remove('is-success');
//         btn.removeAttribute('aria-disabled');
//       }
//     });
//   });

// }
// //////////////////////////////////////////////////////////////////////


// document.addEventListener("DOMContentLoaded", function () {
//   const filterConn = document.querySelector("filter-container");

//   if (filterConn) {
//     const productBlocks = filterConn.querySelectorAll("product-block");

//     productBlocks.forEach((block) => {
//       block.addEventListener("click", function () {
//         // Wait for the popup to fully render
//         setTimeout(() => {
//           const inputRows = document.querySelectorAll(".product-form .input-row");

//           if (inputRows.length > 0) {
//             const swatchItemsContainer = inputRows[0];

//             const swatchLists = swatchItemsContainer.querySelectorAll(
//               "variant-king-combined-listing .swatches ul.swatch-view"
//             );

//             if (swatchLists.length > 0) {
//               swatchLists.forEach((swatchList) => {
//                 const swatchItems = swatchList.querySelectorAll("li.swatch-view-item");

//                 swatchItems.forEach((swatchItem) => {
//                   const imageWrapper = swatchItem.querySelector(".swatch-custom-image");
//                   // console.log(imageWrapper,"=======================");
                  
//                   if (imageWrapper) {
//                     // Overwrite third-party click logic
//                     imageWrapper.addEventListener("click", function (e) {
//                       e.preventDefault();           // Prevent default browser behavior
//                       e.stopPropagation();          // Stop bubbling up to parents
//                       e.stopImmediatePropagation(); // ⛔ Stop other attached listeners (like the third-party one)
//                       // console.log("Swatch click blocked");
//                     }, true); // Use capture phase to block before 3rd party listener runs
//                   }
//                 });
//               });
//             }
//           }
//         }, 3500); // Delay to wait for popup to fully render
//       });
//     });
//   }
// });


// // =====================


// // ===================== slick slider ==================
// function initSlickSlider() {
//   if ($(window).width() < 768) {
//     $('.slider_enabled').each(function () {
//       if (!$(this).hasClass('slick-initialized')) {
//         $(this).slick({
//           dots: false,
//           arrows: true,
//           infinite: false,
//           speed: 800,
//           slidesToShow: 4,
//           slidesToScroll: 1,
//           responsive: [
//             { 
//               breakpoint: 767,
//               settings: {
//                 slidesToShow: 4,
//                 slidesToScroll: 1
//               }
//             },
//             {
//               breakpoint: 700,
//               settings: {
//                 slidesToShow: 4,
//                 slidesToScroll: 1
//               }
//             },
//             {
//               breakpoint: 520,
//               settings: {
//                 slidesToShow: 4, 
//                 slidesToScroll: 1,
//                 centerMode: false, 
//                 dots: false,
//                 arrows: true
//               }
//             }
//           ]
//         });
//       }
//     });
//   } else {
//     $('.slider_enabled.slick-initialized').slick('unslick');
//   }
// }

// window.addEventListener("facet_filter_change", () => {
//   setTimeout(() => {
//     initSlickSlider();
//   }, 0);
// });

// // Run on document ready
// $(document).ready(function () {
//   initSlickSlider();
// });

// // Run on window resize
// $(window).on('resize', function () {
//   initSlickSlider();
// });

// // Helper: Run this after AJAX content is loaded
// function reInitSliderAfterAjax() {
//   initSlickSlider();
// }

// document.addEventListener("DOMContentLoaded", function () {

//   document.querySelectorAll(".price-row").forEach(function (row) {

//     const priceEl = row.querySelector(".price__current");
//     const labelEl = row.closest(".associated-product")?.querySelector(".custom-product-label");
//     const targetEl = row.querySelector(".per-item_price");

//     if (!priceEl || !targetEl || !labelEl) return;

//     // Get numeric price from .price__current (removes currency symbols)
//     const priceValue = parseFloat(
//       priceEl.textContent.replace(/[^0-9.]/g, "")
//     );

//     // Get numeric bundle/label value
//     const labelValue = parseFloat(
//       labelEl.textContent.replace(/[^0-9.]/g, "")
//     );

//     if (!priceValue || !labelValue || labelValue <= 0) {
//       targetEl.style.display = "none";
//       return;
//     }

//     // Divide price by label number
//     const perItemPrice = (priceValue / labelValue).toFixed(2);

//     // Save to attribute
//     targetEl.setAttribute("price", perItemPrice);

//     // (Optional) show value visually
//     targetEl.textContent = perItemPrice;

//   });

// });


// /* Preserve the currently selected variant options (e.g. Size, Color) when the user
//    clicks a .custom-product-label link that navigates to an associated product
//    (e.g. switching from 1-pack to 2 Packs). The destination is a different product
//    so variant IDs don't translate — instead we forward the option *values* as URL
//    search params keyed by option name (`?Size=XXL&Color=Red`). variant-picker.js
//    already exposes applySearchParams() which re-selects matching radios/dropdowns
//    on load, so the size stays selected after the page reload. */
// document.addEventListener('click', function (e) {
//   const labelEl = e.target.closest('.custom-product-label');
//   if (!labelEl) return;

//   const linkEl = labelEl.closest('a[href]');
//   if (!linkEl) return;

//   const href = linkEl.getAttribute('href');
//   if (!href || href.startsWith('#') || href.startsWith('javascript:')) return;

//   /* Read selected option from the primary variant-picker selectors only. There can
//      be additional Color fieldsets inside .customSwatchesCon (bundle products) that
//      share the same data-option name, so dedupe by name and keep the first match. */
//   const seen = new Set();
//   const params = [];
//   document.querySelectorAll('variant-picker .option-selector[data-option]').forEach((selector) => {
//     const optName = selector.dataset.option;
//     if (!optName || seen.has(optName)) return;

//     let value = null;
//     if (selector.dataset.selectorType === 'dropdown') {
//       const selected = selector.querySelector('.custom-select__option[aria-selected="true"]');
//       value = selected && selected.dataset.value ? selected.dataset.value : null;
//     } else {
//       const checkedInput = selector.querySelector('input:checked');
//       value = checkedInput ? checkedInput.value : null;
//     }

//     if (value) {
//       seen.add(optName);
//       params.push([optName, value]);
//     }
//   });

//   if (!params.length) return;

//   try {
//     const url = new URL(href, window.location.origin);
//     params.forEach(([k, v]) => url.searchParams.set(k, v));
//     /* Drop ?variant=… — variant IDs are per-product, so the value from the current
//        page would be wrong on the destination product and override our option params. */
//     url.searchParams.delete('variant');
//     linkEl.setAttribute('href', url.pathname + url.search + url.hash);
//   } catch (err) {
//     /* If URL parsing fails (e.g. unusual href), leave the original href untouched. */
//   }
// }, true);



const prdBundleIds = [];
const prdBundlePrices = [];
const itsPrdIds = [];
let presentClickedBtn;
let isMobile = false;
// Select the parent element with the class 'prd-bundle-main-container'
const parentElement = document.querySelector('.prd-bundle-main-container');

// Find the hidden input elements within the parent container
const maxBundleLimit = parentElement?.querySelector('input[name="max_bundle_limit"]')?.value;
const minBundleLimit = parentElement?.querySelector('input[name="min_bundle_limit"]')?.value;
let variantUnavailable = false;

function formatBundleMoney(cents, format) {
  format = format || '${{amount}}';
  cents = Math.round(Number(cents) || 0);
  const amount = (cents / 100);
  const withDecimals = (val, places, thousand, decimal) => {
    const fixed = Math.abs(val).toFixed(places);
    const parts = fixed.split('.');
    parts[0] = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + (thousand || ','));
    return (val < 0 ? '-' : '') + parts.join(places ? (decimal || '.') : '');
  };
  return format
    .replace(/\{\{\s*amount\s*\}\}/g, withDecimals(amount, 2, ',', '.'))
    .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, withDecimals(amount, 0, ',', ''))
    .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withDecimals(amount, 2, '.', ','))
    .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, withDecimals(amount, 0, '.', ''))
    .replace(/\{\{\s*amount_with_space_separator\s*\}\}/g, withDecimals(amount, 2, ' ', '.'))
    .replace(/\{\{\s*amount_no_decimals_with_space_separator\s*\}\}/g, withDecimals(amount, 0, ' ', ''))
    .replace(/\{\{\s*amount_with_period_and_space_separator\s*\}\}/g, withDecimals(amount, 2, ' ', '.'));
}

function updateBundleSummary() {
  const containers = document.querySelectorAll('.prd-bundle-main-container');
  if (!containers.length) return;
  const subtotal = prdBundlePrices.reduce((sum, p) => sum + (Number(p) || 0), 0);
  containers.forEach(container => {
    const moneyFormat = container.dataset.moneyFormat || '${{amount}}';
    const maxQty = parseInt(container.dataset.bundleMax, 10) || parseInt(maxBundleLimit, 10) || 0;
    const discountPct = parseFloat(container.dataset.bundleDiscount) || 0;
    const count = prdBundleIds.length;
    const discountActive = count > 0 && discountPct > 0;
    const discount = discountActive ? Math.round(subtotal * discountPct / 100) : 0;
    const total = subtotal - discount;

    // Step circles — N selected products complete N circles; the next upcoming
    // step (count + 1) gets the active/current state (green border + green check).
    const steps = container.querySelectorAll('.prd-bundle-step');
    steps.forEach(step => {
      const stepNum = parseInt(step.dataset.step, 10) || 0;
      step.classList.remove('is-completed', 'is-current', 'is-pending');
      if (stepNum > 0 && count >= stepNum) step.classList.add('is-completed');
      // Only highlight the next upcoming step once at least one item is selected.
      // With nothing selected, every step stays pending so the steps look exactly
      // like the default (fresh page load) render.
      else if (stepNum > 0 && count > 0 && stepNum === count + 1) step.classList.add('is-current');
      else step.classList.add('is-pending');

      // Completed steps get a small remove (×) icon at the top-left of the circle.
      // Clicking it unselects the matching bundle item (step N → the Nth selected
      // item) by triggering that item's existing remove button, so every downstream
      // behaviour (arrays, placeholders, button states, totals) runs exactly as before.
      const circle = step.querySelector('.prd-bundle-step__circle');
      if (circle) {
        let cross = circle.querySelector('.prd-bundle-step__remove');
        if (step.classList.contains('is-completed')) {
          if (!cross) {
            cross = document.createElement('button');
            cross.type = 'button';
            cross.className = 'prd-bundle-step__remove';
            cross.setAttribute('aria-label', 'Remove this item from the bundle');
            cross.innerHTML = '&times;';
            cross.addEventListener('click', (e) => {
              e.preventDefault();
              e.stopPropagation();
              const idx = (parseInt(step.dataset.step, 10) || 0) - 1;
              // Target the same container the items are added to (see addPrdToBundle),
              // so the Nth remove button lines up with the Nth selected item.
              const bundleContainer = document.querySelector('.prd-bundle-container');
              const removeBtns = bundleContainer
                ? bundleContainer.querySelectorAll('.bundle-item .remove-item')
                : [];
              if (idx >= 0 && removeBtns[idx]) removeBtns[idx].click();
            });
            circle.appendChild(cross);
          }
        } else if (cross) {
          cross.remove();
        }
      }
    });

    // Progress line — black up to the last completed step, green from there
    // to the next upcoming (active) step.
    const stepsContainer = container.querySelector('.prd-bundle-steps');
    if (stepsContainer) {
      let progress = 0;       // fraction of the visible track that's filled (black + green)
      let completedStop = 0;  // % within the fill bar where black ends and green begins
      if (maxQty > 1) {
        progress = Math.min(1, Math.max(0, count / (maxQty - 1)));
        if (count > 0) {
          completedStop = (count >= maxQty) ? 100 : ((count - 1) / count) * 100;
        }
      } else if (maxQty === 1 && count >= 1) {
        progress = 1;
        completedStop = 100;
      }
      stepsContainer.style.setProperty('--fill-progress', progress);
      stepsContainer.style.setProperty('--completed-stop', completedStop + '%');
    }

    // Summary: subtotal (compare-at — always visible, strike-through only after 1+ items)
    const subtotalEl = container.querySelector('.js-bundle-subtotal');
    if (subtotalEl) {
      subtotalEl.textContent = formatBundleMoney(subtotal, moneyFormat);
      subtotalEl.classList.toggle('is-strike', count > 0);
    }

    // Savings intro ("You're saving 20%")
    const introEl = container.querySelector('.js-bundle-savings-intro');
    if (introEl) {
      const tpl = container.dataset.textSavingsIntro || "You're saving [percent]%";
      introEl.textContent = tpl
        .replace('[percent]', discountPct)
        .replace('[amount]', formatBundleMoney(discount, moneyFormat));
    }

    // Savings amount ("You save $24.00") — always visible; reads $0.00 when nothing selected
    const savingsAmountEl = container.querySelector('.js-bundle-savings-amount');
    if (savingsAmountEl) {
      const tpl = container.dataset.textSavingsAmount || 'You save [amount]';
      savingsAmountEl.textContent = tpl
        .replace('[amount]', formatBundleMoney(discount, moneyFormat))
        .replace('[percent]', discountPct);
      savingsAmountEl.removeAttribute('hidden');
    }

    // Total (big)
    const totalEl = container.querySelector('.js-bundle-total');
    if (totalEl) totalEl.textContent = formatBundleMoney(total, moneyFormat);

    // CTA total
    const ctaTotalEl = container.querySelector('.js-bundle-cta-total');
    if (ctaTotalEl) ctaTotalEl.textContent = formatBundleMoney(total, moneyFormat);

  });
}



window.addPrdToBundle = function(prd, title, price, featured_image, bundlePrdId, mobileVariantIdn = null, priceCents = 0) {
  window.__lastBundlePriceCents = priceCents;
  // Block add-to-bundle (Quick View + bundle PDP) until Size is selected, matching
  // the required-size validation on the main product page.
  const formScope = prd.closest('.product-form');
  const sizeSelector = formScope?.querySelector('[data-option="Size"], [data-option="size"]');
  if (sizeSelector && !sizeSelector.querySelector('input:checked')) {
    const bundleBtnWrap = prd.closest('.bundle-btn');
    if (bundleBtnWrap) {
      let warning = bundleBtnWrap.previousElementSibling;
      if (!warning || !warning.classList.contains('bundle-btn-warning')) {
        warning = document.createElement('p');
        warning.className = 'bundle-btn-warning';
        warning.style.cssText = 'color:#b00020;font-size:0.875rem;font-weight:600;margin:0 0 8px 0;';
        bundleBtnWrap.parentNode.insertBefore(warning, bundleBtnWrap);
      }
      warning.textContent = 'Please select a size before adding to bundle.';
      if (bundleBtnWrap._warningTimeout) clearTimeout(bundleBtnWrap._warningTimeout);
      bundleBtnWrap._warningTimeout = setTimeout(() => {
        warning.remove();
        bundleBtnWrap._warningTimeout = null;
      }, 4000);
    }
    return;
  }
  
  itsPrdIds.push(bundlePrdId);
  // console.log('itsPrdIds: ', itsPrdIds)
  if(variantUnavailable) return;

  const anotherImgPresent = document.querySelector('carousel-slider .slider .slider__item.is-active .product-media img');
  featured_image = anotherImgPresent.src
  
  let parent = prd.closest('.product-form');
  let prd_inv_div = parent.querySelector('.product-inventory');
  let prd_inv_qty = prd_inv_div.querySelector('.product-inventory__status').dataset.lowQty;
  prd_inv_qty = parseInt(prd_inv_qty);
  let isLowInv = !(Array.from(prd_inv_div.attributes).some(i => i.name === 'hidden'));
  let var_id = prd.closest('buy-buttons').querySelector('form input[name="id"]').value;

  // console.log({prd_inv_qty,prdBundleIds_12345: prdBundleIds.filter(item => item === var_id).length});

  if(isLowInv){
    let count = prdBundleIds.filter(item => item === var_id).length;
    if(prd_inv_qty == count ){ prd.innerHTML = "Out Of Stock"; prd.setAttribute('disabled',''); return; }
  }

  if(prdBundleIds.length > (maxBundleLimit-1)) return;
  
  if(mobileVariantIdn)presentClickedBtn = prd; isMobile = true
  // console.log('bundlePrdId: ', bundlePrdId)

  const bundleContainer = document.querySelector('.prd-bundle-container');
  const productDiv = document.createElement('div');
  productDiv.classList.add('bundle-item');

  const img = document.createElement('img');
  img.src = featured_image;
  img.alt = title;
  img.classList.add('bundle-item-image');
  productDiv.appendChild(img);

  const prdId = findIdForBundle(prd, mobileVariantIdn);  

  const removeBtn = document.createElement('span');
  removeBtn.classList.add('remove-item');
  removeBtn.innerText = '×';
  removeBtn.setAttribute('data-id', prdId);

  removeBtn.addEventListener('click', () => {
    const productId = removeBtn.getAttribute('data-id');
    const productIndex = prdBundleIds.indexOf(productId);
    if (productIndex > -1) {
      prdBundleIds.splice(productIndex, 1);
      itsPrdIds.splice(productIndex, 1);
      prdBundlePrices.splice(productIndex, 1);
    }
    // console.log('itsPrdIds: ', itsPrdIds)
    productDiv.remove();
    if (prdBundleIds.length < getActiveBundleLimits().max) document.querySelectorAll('.prd-bundle-AddToCart').forEach(el => el.classList.add('disabled'));
    if (mobileVariantIdn) changeBtnText(prd, true);
    else changeBtnText(document.getElementById(bundlePrdId), true);
    if (prdBundleIds.length < maxBundleLimit) disableAllBtns(false);

    // Append placeholder if there are no more products
    if (prdBundleIds.length < maxBundleLimit) {
        const placeholderDiv = document.createElement('div');
        placeholderDiv.classList.add('bundle-item');
        const placeholderImg = document.createElement('img');
        placeholderImg.src = "https://cdn.shopify.com/s/files/1/1106/6370/files/placeholder.png?v=1739168958";
        placeholderImg.alt = "Placeholder image";
        placeholderImg.classList.add('bundle-placeholder-img');
        placeholderDiv.appendChild(placeholderImg);
        bundleContainer.appendChild(placeholderDiv);
    }
    updateBundleSummary();
  });

  productDiv.appendChild(removeBtn);

  // Check if a placeholder exists
  const placeholderImage = bundleContainer.querySelector('.bundle-placeholder-img');

  if (placeholderImage) {
      // Insert before placeholder if it exists
      bundleContainer.insertBefore(productDiv, placeholderImage.closest('.bundle-item'));
  } else {
      // If no placeholder, insert at the start of the container
      bundleContainer.appendChild(productDiv);
  }

  // Remove placeholder if product is added
  if (placeholderImage) { placeholderImage.closest('.bundle-item').remove() }

  const targetDiv = document.querySelector('.filter-container .filters .filters__inner');
  const targetDivScroll = document.querySelector('.filter-container .filters');
  if (targetDiv) {
      let scrollHeightDiv = targetDivScroll.scrollHeight + bundleContainer.scrollHeight; 
      setTimeout(()=>{ targetDivScroll.scrollTop = scrollHeightDiv },200)
      // console.log('adddded',scrollHeightDiv );
  } // else { console.log("Div not found!"); }
}


function findIdForBundle(prd, mobileVariantIdn) {
    if(!mobileVariantIdn){
        const productIdInput = document.querySelector('input[name="id"]');
        if (productIdInput) {
            thisisId(prd, productIdInput.value);
        } else {
            console.error('Product ID input not found!');
        }
        return(productIdInput.value);
    }
    else{
        thisisId(prd, mobileVariantIdn);
        return(mobileVariantIdn);
    }
}

function thisisId(prd, id) {
    prdBundleIds.push(id);
    const priceCentsToTrack = parseInt(window.__lastBundlePriceCents, 10) || 0;
    prdBundlePrices.push(priceCentsToTrack);
    // console.log('prdBundlesIds: ', prdBundleIds)
    if(prdBundleIds.length == maxBundleLimit ){
        disableAllBtns(true);

    }
    if (prdBundleIds.length >= getActiveBundleLimits().max) {
        document.querySelectorAll('.prd-bundle-AddToCart').forEach(el => el.classList.remove('disabled'));
    }
    const parentContainer = prd.closest('.quickbuy-container');
    if (parentContainer) {
        const closeButton = parentContainer.querySelector('.close-detail');
        if (closeButton) {
            closeButton.click();
        }
    }
    changeBtnText(presentClickedBtn);
    updateBundleSummary();
}

function bundlePopupOpen(btn) {  
  if(prdBundleIds.length > (maxBundleLimit-1)) return;
  presentClickedBtn = btn;
  const parentContainer = btn.closest('.image-cont');
  const quickbuyButton = parentContainer.querySelector('.quickbuy-toggle');
  if (quickbuyButton) {
      quickbuyButton.click();
  }
}

function openQuickView(e, btn, product_id){  
  e.preventDefault();
  if(prdBundleIds.length > (maxBundleLimit-1)) return;
  const parentContainer = btn.closest('.image-cont') || btn.closest('.block-inner-inner');
  presentClickedBtn = parentContainer.querySelector('.bundle-popup-open p');
  const quickbuyButton = parentContainer.querySelector('.quickbuy-toggle');
  if (quickbuyButton) {
      quickbuyButton.click();
  }
}

function changeBtnText(btn, remove=false){
    // console.log('changeBtnText btn: ', btn)
    // if(remove){
    //     btn.innerText = 'Add To Bundle';
    //     btn.closest('.bundle-popup-open').classList.remove('disabled');

    // }
    // else{
    //     btn.innerText = 'Added';
    //     btn.closest('.bundle-popup-open').classList.add('disabled');
    // }
}

function disableAllBtns(disable){
    if(disable){
        document.querySelectorAll('.bundle-popup-open p').forEach((singleBtn)=>{
            singleBtn.style.opacity = '0.5'
            singleBtn.style.cursor = 'default'
        })
    }
    else{
        document.querySelectorAll('.bundle-popup-open p').forEach((singleBtn)=>{
            singleBtn.style.opacity = '1'
            singleBtn.style.cursor = 'pointer'
        })
    }
}

// function updateBundleBtn(){
//   itsPrdIds.forEach((bundlePrdId)=>{
//     changeBtnText(document.getElementById(bundlePrdId), false);
//   })
// }

function getActiveBundleLimits() {
  const container = document.querySelector('.prd-bundle-main-container:not([style*="display: none"])')
                 || document.querySelector('.prd-bundle-main-container');
  const maxVal = parseInt(container?.dataset?.bundleMax, 10)
              || parseInt(container?.querySelector('input[name="max_bundle_limit"]')?.value, 10)
              || parseInt(maxBundleLimit, 10)
              || 3;
  const minVal = parseInt(container?.dataset?.bundleMin, 10)
              || parseInt(container?.querySelector('input[name="min_bundle_limit"]')?.value, 10)
              || parseInt(minBundleLimit, 10)
              || 1;
  return { max: maxVal, min: minVal };
}

async function addBundleToCart(btn) {
  if (!prdBundleIds || !prdBundleIds.length) return;

  const atcWrapper = btn.closest('.prd-bundle-AddToCart');
  if (atcWrapper && (atcWrapper.classList.contains('disabled') || atcWrapper.classList.contains('is-loading'))) {
    return;
  }

  const allAtcButtons = document.querySelectorAll('.prd-bundle-AddToCart');
  allAtcButtons.forEach(el => el.classList.add('is-loading'));

  const labelEl = btn.querySelector('.prd-bundle-cta__label') || btn;
  const prevLabelText = labelEl.textContent;
  labelEl.textContent = 'Adding...';

  try {
    const rawDiscountCode = atcWrapper?.dataset?.discountCode;
    const discount_code = typeof rawDiscountCode === 'string' ? rawDiscountCode.trim() : '';
    const hasDiscountCode = !!(discount_code && discount_code !== 'undefined' && discount_code !== 'null');

    const cartDrawerEl = document.querySelector('.js-cart-drawer') || document.querySelector('cart-drawer');
    const cartFormEl = cartDrawerEl?.querySelector('cart-form') || document.querySelector('cart-form');
    const cartDrawerSectionId = cartDrawerEl?.dataset?.sectionId || cartFormEl?.dataset?.sectionId;
    const headerEl = document.querySelector('page-header') || document.querySelector('.page-header');
    const headerSectionId = headerEl?.dataset?.sectionId;

    const sectionIdsToRequest = [cartDrawerSectionId, headerSectionId].filter(Boolean);

    // Shared properties let the cart drawer / cart page group these lines as one bundle
    const mixBundleId = 'mix-' + Date.now();
    // First item added = main (parent) product; the rest are its bundle items
    // Title for the cart summary bar (collection metafield custom.bundle_product_title, else collection name)
    const mixBundleTitle = (atcWrapper?.dataset?.bundleTitle || '').trim();
    const payload = {
      items: prdBundleIds.map((id, idx) => ({
        id: Number(id) || id,
        quantity: 1,
        properties: idx === 0
          ? { _bundle_id: mixBundleId, _bundle_parent: 'true', _bundle_order: '0', _bundle_title: mixBundleTitle }
          : { _bundle_id: mixBundleId, _bundle_order: String(idx) }
      }))
    };

    if (sectionIdsToRequest.length > 0) {
      payload.sections = sectionIdsToRequest.join(',');
      payload.sections_url = window.location.pathname;
    }

    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json, text/javascript'
      },
      body: JSON.stringify(payload)
    });

    if (!response.ok) {
      let errBody = '';
      try { errBody = await response.text(); } catch (e) {}
      console.error('cart/add.js rejected:', response.status, errBody, 'payload:', payload);
      throw new Error(`Failed to add items to cart (status ${response.status})`);
    }

    const data = await response.json();

    // Apply the discount cookie after the add, without blocking it (Safari/iOS can fail or hang on this redirecting request)
    if (hasDiscountCode) {
      fetch(`/discount/${encodeURIComponent(discount_code)}`, { credentials: 'same-origin' })
        .catch(discountErr => console.warn('Discount fetch failed:', discountErr));
    }

    if (data && (data.items || !data.status)) {
      if (window.klaviyoTrackAddToCart) {
        try { window.klaviyoTrackAddToCart(data); } catch (e) {}
      }

      // Update cart drawer directly using returned section HTML or fallback
      let drawerHtml = null;
      if (data.sections && cartDrawerSectionId && data.sections[cartDrawerSectionId]) {
        drawerHtml = data.sections[cartDrawerSectionId];
      } else if (data.sections) {
        const matchingKey = Object.keys(data.sections).find(k => k.includes('cart-drawer'));
        if (matchingKey) drawerHtml = data.sections[matchingKey];
      }

      if (drawerHtml && cartFormEl) {
        const doc = new DOMParser().parseFromString(drawerHtml, 'text/html');
        const newCartForm = doc.querySelector('cart-form[data-section-id="' + cartDrawerSectionId + '"]') || doc.querySelector('cart-form');
        if (newCartForm) {
          cartFormEl.innerHTML = newCartForm.innerHTML;
          if (window.theme && typeof theme.manuallyLoadImages === 'function') {
            theme.manuallyLoadImages(cartFormEl);
          }
          cartFormEl.querySelectorAll('cc-cart-cross-sell').forEach(el => {
            if (typeof el.init === 'function') el.init();
          });
          cartFormEl.querySelectorAll('script').forEach(oldScript => {
            const newScript = document.createElement('script');
            for (const attr of oldScript.attributes) newScript.setAttribute(attr.name, attr.value);
            newScript.textContent = oldScript.textContent;
            oldScript.parentNode.replaceChild(newScript, oldScript);
          });
        } else if (typeof cartFormEl.refresh === 'function') {
          cartFormEl.refresh();
        }
      } else if (cartFormEl && typeof cartFormEl.refresh === 'function') {
        // add.js did not return the drawer section: let the theme re-fetch it so the drawer never stays stale/empty
        cartFormEl.refresh();
      } else if (cartDrawerSectionId && typeof refreshCartFromSections === 'function') {
        await refreshCartFromSections(cartDrawerSectionId);
      }

      // Update header cart count / icon
      let headerHtml = null;
      if (data.sections && headerSectionId && data.sections[headerSectionId]) {
        headerHtml = data.sections[headerSectionId];
      } else if (data.sections) {
        const matchingKey = Object.keys(data.sections).find(k => k.includes('header'));
        if (matchingKey) headerHtml = data.sections[matchingKey];
      }
      if (headerHtml) {
        const headerDoc = new DOMParser().parseFromString(headerHtml, 'text/html');
        const newCartLink = headerDoc.querySelector('.cart-link');
        const curCartLink = document.querySelector('.cart-link');
        if (newCartLink && curCartLink) {
          curCartLink.innerHTML = newCartLink.innerHTML;
        }
      }

      if (typeof free_gift_Updates === 'function') {
        try { free_gift_Updates(); } catch (e) {}
      }

      // Open the drawer
      if (cartDrawerEl && typeof cartDrawerEl.open === 'function') {
        cartDrawerEl.open();
      } else {
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open', { bubbles: true }));
      }
    }
  } catch (error) {
    console.error('Error adding bundle to cart:', error);
  } finally {
    if (labelEl) {
      labelEl.textContent = prevLabelText;
    }
    allAtcButtons.forEach(el => el.classList.remove('is-loading'));
  }
}

window.addBundleToCart = addBundleToCart;



document.addEventListener('DOMContentLoaded', function() {
  const element = document.querySelector('.filter-container.filter-container--side.bundle-collection');
  const mobileContainer = document.querySelector('.prd-bundle-main-container.for_mobile');
  const desktopHeading = document.querySelector('.filter-group__heading__text.for_desktop');
  const desktopContainer = document.querySelector('.prd-bundle-main-container.for_desktop');
  
  // Show the filter group items
  document.querySelectorAll('.filter-group__heading').forEach(item => item.style.pointerEvents = 'none' );

  document.querySelectorAll('.filter-group__heading.toggle-target-toggler--is-hidden').forEach(item => item.classList.remove('toggle-target-toggler--is-hidden'));
  document.querySelector('.filter-group__items.filter-group--3.toggle-target.toggle-target--hidden')?.classList.remove('toggle-target--hidden');

  // Corrected the variable names in the console log
  // console.log('mobileContainer: ', mobileContainer, ' desktopHeading: ', desktopHeading, ' desktopContainer: ', desktopContainer);

  // Handle display based on screen size
  if (window.innerWidth <= 999) {
    element?.classList.replace('filter-container--show-filters-desktop', 'filter-container--show-filters-mobile');
    if (mobileContainer) { mobileContainer.style.display = 'block'}
    if (desktopHeading) { desktopHeading.remove() }
    if (desktopContainer) { desktopContainer.remove() }

    const mobileFiltersWrap = document.querySelector('.filter-container .filters.mobile-sticky-maincontainer');
    const desktopFiltersWrap = document.querySelector('.filter-container .filters:not(.mobile-sticky-maincontainer)');
    if (mobileFiltersWrap && desktopFiltersWrap) {
      mobileFiltersWrap.addEventListener('change', (evt) => {
        const src = evt.target;
        if (!src || !src.matches || !src.matches('input, select, textarea')) return;
        const escName = CSS.escape(src.name);
        if (src.type === 'radio') {
          desktopFiltersWrap.querySelectorAll(`input[type="radio"][name="${escName}"]`).forEach((el) => {
            el.checked = (el.value === src.value);
          });
        } else if (src.type === 'checkbox') {
          const dst = desktopFiltersWrap.querySelector(`input[type="checkbox"][name="${escName}"][value="${CSS.escape(src.value)}"]`);
          if (dst) dst.checked = src.checked;
        } else {
          const dst = desktopFiltersWrap.querySelector(`[name="${escName}"]`);
          if (dst) dst.value = src.value;
        }
      });
    }
  } else {
    element?.classList.replace('filter-container--show-filters-mobile', 'filter-container--show-filters-desktop');
    if (desktopHeading) { desktopHeading.style.display = 'block' }
    if (desktopContainer) { desktopContainer.style.display = 'block' }
    if (mobileContainer) { mobileContainer.remove() }
  }
});


/* 

console.log('working custom-mw.js');

const prdBundleIds = [];
let presentClickedBtn;
// Select the parent element with the class 'prd-bundle-main-container'
const parentElement = document.querySelector('.prd-bundle-main-container');

// Find the hidden input elements within the parent container
const maxBundleLimit = parentElement.querySelector('input[name="max_bundle_limit"]').value;
const minBundleLimit = parentElement.querySelector('input[name="min_bundle_limit"]').value;

// Log the values to the console (you can also use these values in your code)
console.log('Max Bundle Limit:', maxBundleLimit);
console.log('Min Bundle Limit:', minBundleLimit);


function addPrdToBundle(prd, title, price, featured_image, bundlePrdId) {
    console.log('bundlePrdId: ', bundlePrdId)
    const bundleContainer = document.querySelector('.prd-bundle-container');
    const productDiv = document.createElement('div');
    productDiv.classList.add('bundle-item');

    const img = document.createElement('img');
    img.src = featured_image;
    img.alt = title;
    img.classList.add('bundle-item-image');
    productDiv.appendChild(img);

    const prdId = findIdForBundle(prd);

    const removeBtn = document.createElement('span');
    removeBtn.classList.add('remove-item');
    removeBtn.innerText = '×';

    removeBtn.setAttribute('data-id', prdId);

    removeBtn.addEventListener('click', () => {
        const productId = removeBtn.getAttribute('data-id');
        const productIndex = prdBundleIds.indexOf(productId);
        if (productIndex > -1) prdBundleIds.splice(productIndex, 1);
        console.log('prdBundleIds after: ', prdBundleIds)
        productDiv.remove();
        if (prdBundleIds.length < minBundleLimit ) document.querySelector('.prd-bundle-AddToCart').classList.add('disabled');
        changeBtnText( document.getElementById(bundlePrdId) , true);
        if(prdBundleIds.length < maxBundleLimit ) disableAllBtns(false);
    });

    productDiv.appendChild(removeBtn);
    bundleContainer.appendChild(productDiv);
}


function findIdForBundle(prd) {
    const productIdInput = document.querySelector('input[name="id"]');
    if (productIdInput) {
        thisisId(prd, productIdInput.value);
    } else {
        console.error('Product ID input not found!');
    }
    return(productIdInput.value);
}

function thisisId(prd, id) {
    prdBundleIds.push(id);
    console.log('prdBundlesIds: ', prdBundleIds)
    if(prdBundleIds.length == maxBundleLimit ){
        disableAllBtns(true);
       
    }
    if (prdBundleIds.length >= minBundleLimit) {
        document.querySelector('.prd-bundle-AddToCart').classList.remove('disabled');
    }
    const parentContainer = prd.closest('.quickbuy-container');
    if (parentContainer) {
        const closeButton = parentContainer.querySelector('.close-detail');
        if (closeButton) {
            closeButton.click();
        }
    }
    changeBtnText(presentClickedBtn);
}

function bundlePopupOpen(btn) {    
    if(prdBundleIds.length > (maxBundleLimit-1)) return;
    presentClickedBtn = btn;
    const parentContainer = btn.closest('.image-cont');
    const quickbuyButton = parentContainer.querySelector('.quickbuy-toggle');
    if (quickbuyButton) {
        quickbuyButton.click();
    }
}

function changeBtnText(btn, remove=false){
    console.log('changeBtnText btn: ', btn)
    if(remove){
        btn.innerText = 'Add To Bundle';
        btn.closest('.bundle-popup-open').classList.remove('disabled');

    }
    else{
        btn.innerText = 'Added';
        btn.closest('.bundle-popup-open').classList.add('disabled');
    }
}

function disableAllBtns(disable){
    if(disable){
        document.querySelectorAll('.bundle-popup-open p').forEach((singleBtn)=>{
            singleBtn.style.opacity = '0.5'
            singleBtn.style.cursor = 'default'
        })
    }
    else{
        document.querySelectorAll('.bundle-popup-open p').forEach((singleBtn)=>{
            singleBtn.style.opacity = '1'
            singleBtn.style.cursor = 'pointer'
        })
    }
}

async function addBundleToCart(btn) {
    btn.innerText = 'Loading..'
    const formData = {
        items: prdBundleIds.map(id => ({ id, quantity: 1 }))
    };
    try {
        const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(formData)
        });
        const data = await response.json();
        if (data && data.items) {
            window.location.href = '/cart';
            // const drawer = document.querySelector('.drawer');
            // if (!drawer.classList.contains('active')) {
            //     drawer.classList.remove("is-empty");
            //     drawer.classList.add("active");
            //     drawer.setAttribute('open', 'true');
            //     document.body.classList.add('overflow-hidden');
            // }
            // $('.drawer').load(location.href + ' .cart-drawer');
            // $('.cart-link__icon').load(location.href + ' .cart-link__icon');
        }
    } catch (error) {
        console.error('Error: ', error);
    }
}

*/



// -----------------------------------------
  
let finalSelectedVariants = [];
const discountPer = (100 - document.querySelector('[color_discount]')?.getAttribute('color_discount')) / 100 || null;

function colorsInputChangeHandler(inpElm, optName, optionSelectedValue) {
  
  // variantUnavailable = inpElm.classList.contains('is-unavailable');
  setTimeout(() => {
    let get_all_checked_inputs = inpElm?.closest('variant-picker').querySelectorAll('input:checked');
    variantUnavailable =  Array?.from(get_all_checked_inputs)?.some( i => i.classList.contains('is-unavailable'))
  
    let bundle_btn = inpElm.closest('.product-form').querySelector('.bundle-btn .add-to-bundle');
    if(!bundle_btn) return;
    if(variantUnavailable){ bundle_btn.innerHTML = 'Out Of Stock'; bundle_btn.setAttribute('disabled','') }
    else{ bundle_btn.innerHTML = 'Add To Bundle'; bundle_btn.removeAttribute('disabled','') }
  }, 100);

  // console.log('prdBundleIds colorsInputChangeHandler',prdBundleIds);
  


  const colorBundle = document.querySelector('.color_bundle');
  if(!colorBundle){ return } 

  const variantScript = document.querySelector('variant-picker script');
  const variantsData = JSON.parse(variantScript.textContent);
    
  if (optionSelectedValue) {
    const optionSelector = inpElm.closest('.customSwatchesCon');
    const spanHeadingColor = optionSelector.querySelector('.option-selector__label-value');
    spanHeadingColor.innerText = inpElm.value;
  }

  const checkedInputSize = document.querySelector('fieldset[data-option="Size"] input:checked');
  const allCheckedInputColor = document.querySelectorAll('fieldset[data-option="Color"] input:checked');
  let selectedOptions = [];

  if (!inpElm) {
    handleUnavailableVariants(checkedInputSize);
    return;
  }

  if (optName === 'Color') {
    handleColorSelection(inpElm, checkedInputSize);
  } else if (allCheckedInputColor?.length > 0) {
    allCheckedInputColor.forEach(checkedInputColor => handleVariantSelection(inpElm, checkedInputSize, checkedInputColor));
  }

  updateAddToCartButton();

  function handleColorSelection(inpElm, checkedInputSize) {
    selectedOptions = [checkedInputSize.value, inpElm.value];
    const selectedVariant = findSelectedVariant(selectedOptions);
    updateSelectedOptions(inpElm.name, selectedVariant?.id, selectedVariant.featured_image, selectedVariant.featured_media.id, selectedVariant.price, selectedVariant?.compare_at_price);

    if (!selectedVariant?.available) {
      removeUnavailableVariant(selectedVariant);
    }
  }

  function handleVariantSelection(inpElm, checkedInputSize, checkedInputColor) {
    selectedOptions = [inpElm.value, checkedInputColor.value];
    const selectedVariant = findSelectedVariant(selectedOptions);

    updateSelectedOptions(checkedInputColor.name, selectedVariant?.id, selectedVariant.featured_image, selectedVariant.featured_media.id, selectedVariant.price, selectedVariant?.compare_at_price);
    resetUnavailableClasses();

    const unavailableVariants = findUnavailableVariants(checkedInputSize.value);
    if (unavailableVariants?.length > 0) {
      markUnavailableVariants(unavailableVariants);
    }
  }

  function findSelectedVariant(options) {
    return variantsData.variants.find(v => v.options.every((val, index) => val === options[index]));
  }

  function updateSelectedOptions(name, value, featureImgSrc, featuredMediaId, variantPrice, compareAtPrice = null) {

  // console.log(selectedOptions,'selected options here');
  
  
    const sideImagesWrapper = document.querySelector('.side-images-wrapper');
    
    // Check if the side-images-container already exists by looking for the specific id
    let sideImageContainer = document.getElementById(`side-img-${name}`);

    const firstMainImage = document.querySelector(`.product-media-collage [data-media-id="${featuredMediaId}"]`);
    const mainImage = firstMainImage?.querySelector(`img`);
    document.querySelector('[imgActive]')?.removeAttribute('imgActive');

  if(sideImageContainer){
    const imgElement = sideImageContainer.querySelector('img');
    const mediaId = sideImageContainer.getAttribute('featured-media-id');

      if (imgElement) {
          imgElement.src = featureImgSrc.src;
          imgElement.alt = featureImgSrc.alt;
          // imgElement.removeAttribute('featured-media-id');
          sideImageContainer.setAttribute('featured-media-id', featuredMediaId);
          sideImageContainer.setAttribute('imgActive', '');
          
          sideImageContainer.setAttribute('options-atr', `${selectedOptions[0]}-----${selectedOptions[1]}`);
          

      }
      }else{
        sideImageContainer = document.createElement('div');
        sideImageContainer.classList.add('side-images-container');
        sideImageContainer.id = `side-img-${name}`;
        sideImageContainer.setAttribute('featured-media-id', featuredMediaId);
        sideImageContainer.setAttribute('imgActive', '');
        sideImageContainer.setAttribute('options-atr', `${selectedOptions[0]}-----${selectedOptions[1]}`);
        sideImageContainer.addEventListener('click',()=>{
          sideImagesMediaChange(`side-img-${name}`);
        })

        // Create the image element
        const imgElement = document.createElement('img');
        imgElement.classList.add('slider-image');
        imgElement.src = featureImgSrc.src;
        imgElement.alt = featureImgSrc.alt;

        // Append the image element to the container
        sideImageContainer.appendChild(imgElement);

        // Append the new container to the side-images-wrapper
        sideImagesWrapper.appendChild(sideImageContainer);
  
  }

    const existingOptionIndex = finalSelectedVariants.findIndex(option => option[name] !== undefined);
    if (existingOptionIndex !== -1) {
      finalSelectedVariants[existingOptionIndex][name] = value;
      finalSelectedVariants[existingOptionIndex].price = variantPrice;
      finalSelectedVariants[existingOptionIndex].compareAtPrice = compareAtPrice;
      finalSelectedVariants[existingOptionIndex].featuredMediaId = featuredMediaId;

    } else {
      finalSelectedVariants.push({ [name]: value, price: variantPrice, compareAtPrice: compareAtPrice, featuredMediaId:featuredMediaId });
    }

  }

  function handleUnavailableVariants(checkedInputSize) {
    if (allCheckedInputColor?.length > 0) {
      allCheckedInputColor.forEach(checkedInputColor => {        
        selectedOptions = [checkedInputSize.value, checkedInputColor.value];
        const selectedVariant = findSelectedVariant(selectedOptions);
        updateSelectedOptions(checkedInputColor.name, selectedVariant?.id, selectedVariant.featured_image, selectedVariant.featured_media.id, selectedVariant.price, selectedVariant?.compare_at_price);
      });
    }

    resetUnavailableClasses();
    const unavailableVariants = findUnavailableVariants(checkedInputSize.value);
    if (unavailableVariants?.length > 0) {
      markUnavailableVariants(unavailableVariants);
    }
  }

  function resetUnavailableClasses() {
    document.querySelectorAll('.customSwatchesCon input[type="radio"].is-unavailable')
      .forEach(elm => elm.classList.remove('is-unavailable'));

       document.querySelectorAll('variant-picker input[type="radio"].is-unavailable')
      .forEach(elm => elm.classList.remove('is-unavailable'));
  }

  function findUnavailableVariants(sizeValue) {
    return variantsData.variants.filter(v => v.option1 === sizeValue && !v.available);
  }

  function markUnavailableVariants(unavailableVariants) {
    unavailableVariants.forEach(unavailableItem => {
      document.querySelectorAll(`.customSwatchesCon input[value='${unavailableItem.option2}']`)
        .forEach(elm => elm.classList.add('is-unavailable'));

         document.querySelectorAll(`variant-picker input[value='${unavailableItem.option2}']`)
        .forEach(elm => elm.classList.add('is-unavailable'));
      removeUnavailableVariant(unavailableItem);
    });
  }

  function removeUnavailableVariant(variant) {
    finalSelectedVariants = finalSelectedVariants.filter(obj => !Object.values(obj).some(value => value === variant.id));
  }

  function updateAddToCartButton() {
    const customAddToCartBtn = document.querySelector('.custom-add-to-cart-btn');
    if (customAddToCartBtn) {
      if (finalSelectedVariants.length > 0) {
        customAddToCartBtn.innerText = "Add To Cart";
        customAddToCartBtn.removeAttribute('disabled');
      } else {
        customAddToCartBtn.setAttribute('disabled', true);
        customAddToCartBtn.innerText = "Sold Out";
      }
    }
  }

  // console.log('hi lovovovdsjojd');
  if (optName === 'Size') {
    document.querySelector('[imgactive]')?.removeAttribute('imgactive');
    const sideImagesContainer = document.querySelectorAll('.side-images-container');
    if(sideImagesContainer?.length > 0){
      sideImagesContainer.forEach((itm,i)=>{
        if(i==0){
          itm.setAttribute('imgactive', '');
        }
      })
    }
  }
  
  const activeMediaObj = document.querySelector('.custom-media-gall-cls media-gallery');
  // console.log(activeMediaObj,'media gg');

  // if(activeMediaObj){ activeMediaObj.style.pointerEvents = 'none' }
  const boundOnVariantChange = activeMediaObj.onVariantChange.bind(activeMediaObj);

  // Calling the method manually
  boundOnVariantChange({
      type: 'on:variant:change',   // Event type (optional)
      detail: { selectedOptions: selectedOptions },  // Event data
  });


  if(finalSelectedVariants.length > 1){
    const sideImagesWrapper = document.querySelector('.side-images-wrapper');
    if(sideImagesWrapper){ sideImagesWrapper.classList.remove('hidden') }

  }
  syncBundleAtcReady();
}

/*
 * Colour-pack Add to Cart highlight.
 * The button is fully highlighted ONLY when every bundle slot (e.g. all 4 in a 4 pack)
 * has an in-stock colour selected, a size is chosen and the cart payload is complete.
 * The state is recomputed from the DOM on every change (colour only, no size change).
 */
function syncBundleAtcReady() {
  const atcBtn = document.querySelector('.custom-add-to-cart-btn');
  if (!atcBtn || !document.querySelector('.color_bundle')) return;

  const slots = document.querySelectorAll('fieldset[data-option="Color"] .option-selector__btns');
  let ready = slots.length > 0;
  slots.forEach(function (slot) {
    const picked = slot.querySelector('input:checked');
    if (!picked || picked.classList.contains('is-unavailable')) ready = false;
  });

  const sizeFieldset = document.querySelector('fieldset[data-option="Size"]');
  if (sizeFieldset && !sizeFieldset.querySelector('input:checked')) ready = false;

  if (typeof finalSelectedVariants === 'undefined' || finalSelectedVariants.length !== slots.length) ready = false;

  // The same variant picked in several slots needs that many units in stock (otherwise Shopify rejects the whole add)
  if (ready) {
    try {
      const pickerData = JSON.parse(document.querySelector('variant-picker script').textContent);
      const wanted = {};
      finalSelectedVariants.forEach(function (item) {
        const vid = String(Object.values(item)[0]);
        wanted[vid] = (wanted[vid] || 0) + 1;
      });
      Object.keys(wanted).forEach(function (vid) {
        const variant = pickerData.variants.find(function (v) { return String(v.id) === vid; });
        if (variant && variant.inventory_management && variant.inventory_policy === 'deny' && wanted[vid] > variant.inventory_quantity) ready = false;
      });
    } catch (err) { /* stock data unavailable: keep the selection-based state */ }
  }

  atcBtn.style.opacity = ready ? '1' : '';
  document.querySelectorAll('button[onclick^="stickyAtcCusButtonHanlder"]').forEach(function (stickyBtn) {
    stickyBtn.style.opacity = ready ? '1' : '0.6';
  });
}

document.addEventListener('DOMContentLoaded', function () {
  const colorBundle = document.querySelector('.color_bundle');
  if(colorBundle){
    // console.log('color bundle class found');

    colorsInputChangeHandler();
    setTimeout(syncBundleAtcReady, 300);
  }
});

// Re-check after any option change (the theme's own availability update runs first, so wait a moment)
document.addEventListener('change', function (e) {
  if (!e.target || !e.target.closest || !e.target.closest('.color_bundle')) return;
  setTimeout(syncBundleAtcReady, 150);
  setTimeout(syncBundleAtcReady, 600);
});


function addToCartBundleVariants(e,btnElm){    
  e.preventDefault();


  const allInputColorSelectors = document.querySelectorAll('fieldset[data-option="Color"] .option-selector__btns');
  const qtySubmitRow = btnElm.closest('.quantity-submit-row__submit');

  if(allInputColorSelectors?.length !== finalSelectedVariants?.length){
    const customVariantSelectionMsg = qtySubmitRow.querySelector('.custom-variant-selection-msg');
    if(customVariantSelectionMsg){
      // customVariantSelectionMsg.classList.remove('hidden');
      customVariantSelectionMsg.style.visibility = 'initial'
      customVariantSelectionMsg.style.height = 'auto'
    }
    setTimeout(()=>{
      // customVariantSelectionMsg.classList.add('hidden');
      customVariantSelectionMsg.style.visibility = 'hidden'
      customVariantSelectionMsg.style.height = '0'
    },3000)
    return;
  }
  
  const allCheckedCus = document.querySelectorAll('.customSwatchesCon input:checked');

// if(finalSelectedVariants.length <= 0){
//   return;
// }

const colorBundleId = 'color-' + Date.now();
const items = finalSelectedVariants?.map((itm, idx)=>({ 'id': Object.values(itm)[0], 'quantity' : 1, properties: idx === 0 ? {_color_bundle: 'bundle', _bundle_id: colorBundleId, _bundle_parent: 'true', _bundle_order: '0'} : {_color_bundle: 'bundle', _bundle_id: colorBundleId, _bundle_order: String(idx)} }))
// console.log(items, 'items here');

// return

  try {
    // btnElm.closest('.quantity-submit-row__submit')?.classList.add('js-product-form');
  btnElm.setAttribute('aria-disabled', 'true');
  btnElm.classList.add('is-loading');

    let formData = {
    'items': items
    };

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(response => {
      return response.json();
    }).then(res=>{
      // Shopify rejected the add (e.g. 422 sold out): do not show success or go to an empty cart
      if (!res || res.status || !res.items) {
        console.error('Bundle add to cart failed:', res);
        btnElm.classList.remove('is-loading');
        btnElm.removeAttribute('aria-disabled');
        return;
      }
      if (window.klaviyoTrackAddToCart) window.klaviyoTrackAddToCart(res);

      // const cartDrawer = document.querySelector('cart-drawer');
      // if(cartDrawer){
      //   cartDrawer.cartRefreshHandler();
      //   cartDrawer.open();
      // }
      btnElm.classList.add('is-success');
        btnElm.removeAttribute('aria-disabled');


        setTimeout(() => {
          if(allCheckedCus.length > 0){
            allCheckedCus.forEach((elm)=>{
              elm.checked = false;
            })
          }
          btnElm.classList.remove('is-loading');
          btnElm.classList.remove('is-success');
          window.location.href = '/cart';
        }, 2000);
        })
    .catch((error) => {
      console.error('Error:', error);
    });
  } catch (error) {
    console.log(error,'err here');

  }
}

function stickyAtcCusButtonHanlder(e){
  e.preventDefault();
  const customAddToCartBtn = document.querySelector('.custom-add-to-cart-btn');
  if(customAddToCartBtn){
    window.scrollTo(0, 100);
    customAddToCartBtn.click();
  }
}

function sideImagesMediaChange(id){
  
  const sideImagesContainer = document.getElementById(id);
  // console.log(sideImagesContainer, 'sideImagesContainer');
  if(sideImagesContainer){
    const curOptions = sideImagesContainer.getAttribute('options-atr');
    const selectedOpts = curOptions.split("-----");


    document.querySelector('[imgactive]')?.removeAttribute('imgactive');
    //   document.querySelectorAll('.no-hidden')?.forEach(img => img.classList.replace('no-hidden', 'hidden'))
    //   handlePrdImage(document.querySelector(`.product-media-collage [data-media-id="${featuredMediaId}"]`))
    // }
    const activeMediaObj2 = document.querySelector('.custom-media-gall-cls media-gallery');
    
    const boundOnVariantChange = activeMediaObj2.onVariantChange.bind(activeMediaObj2);
    
    // Calling the method manually
    boundOnVariantChange({
      type: 'on:variant:change',   // Event type (optional)
      detail: { selectedOptions: selectedOpts },  // Event data
    });

    sideImagesContainer.setAttribute('imgactive', '');

  }

}




const targetElements = document.querySelectorAll("cart-form");
let mutationTimeout;

const free_gift_mutation = (mutationsList) => {
    clearTimeout(mutationTimeout);
    mutationTimeout = setTimeout(() => { free_gift_Updates() }, 500);
};

//////
// function removeHashFromUrl(url) { return url.replace(/:(\w+)(?=&|$)/, '') }
// function removeFreeGift(id){
//   let item = document.querySelector(`cart-form .cart-item-list .cart-item[data-product-id="${id}"]`);
//   let qty_div = item.querySelector('.cart-item__quantity .quantity');
//   let qty_inp = qty_div.querySelector('input');
//   let dec_btn = qty_div.querySelector('#updates_dec_1');
//   qty_inp.value = 1;
//   dec_btn.click();
// }
////

// const free_gift_Updates = () => {
//     // console.log("Cart drawer changed! Running necessary updates...");

//     let free_gift_parent = document.getElementById('cart_free_gift--wrapper');
//     let free_gift_progress = free_gift_parent.querySelector('[data-free-shipping-progress]')?.getAttribute('data-free-shipping-progress');
//     let free_gift_prd_id = free_gift_parent.getAttribute('data-free-gift-id'); 
//     let cart_drawer_list = document.querySelectorAll('cart-form .cart-item-list .cart-item');

//     let free_gift_add_form = free_gift_parent.querySelector('.cart_free_gift__add_form product-form');
//     let free_gift_locked = free_gift_parent.querySelector('.ctm_btn--locked');
//     let cart_item_ids = Array.from(cart_drawer_list).map(e => e.getAttribute('data-product-id'));

//     let count = cart_item_ids.filter(id => id === free_gift_prd_id).length; ////////////    

//     if(cart_drawer_list.length > 0){ free_gift_parent.classList.remove('cart-drawer__footer--hidden') }
//     else{ free_gift_parent.classList.contains('cart-drawer__footer--hidden') ? '' : free_gift_parent.classList.add('cart-drawer__footer--hidden') ; }

//     if(!cart_item_ids.includes(free_gift_prd_id)){
//       if(free_gift_progress != '1'){
//         free_gift_add_form.style.display = 'none';
//         free_gift_locked.style.display = 'block';
//       }else{
//         free_gift_add_form.style.display = 'block';
//         free_gift_locked.style.display = 'none';
//       }
//     }else{

//       // if(free_gift_progress != '1'){ removeFreeGift(free_gift_prd_id) } //////////////
//       // else if(count > 1){ removeFreeGift(free_gift_prd_id) } /////////////

//       free_gift_add_form.style.display = 'none';
//       free_gift_locked.style.display = 'block';
//     }
// };

const free_gift_Updates = () => {
    // console.log("Cart drawer changed! Running necessary updates...");

    let cart_drawer_list = document.querySelectorAll('cart-form .cart-item-list .cart-item');
    let cart_item_ids = Array.from(cart_drawer_list).map(e => e.getAttribute('data-product-id'));

    /* Toggle the form / locked button on a single threshold-gift wrapper. Reused for both
       the 2nd-threshold (#cart_free_gift--wrapper) and 3rd-threshold
       (#cart_second_threshold_gift--wrapper) cards so each one's quantity selector hides
       once its product is added and reappears when the product is removed. */
    const updateGiftWrapper = (wrapperId, idAttr) => {
      const parent = document.getElementById(wrapperId);
      if (!parent) return;

      const prd_id = parent.getAttribute(idAttr);
      const add_form = parent.querySelector('.cart_free_gift__add_form product-form');
      const locked   = parent.querySelector('.ctm_btn--locked');
      const giftCard = parent.querySelector('.cart_free_gift');
      if (!prd_id || !add_form || !locked) return;

      if (cart_drawer_list.length > 0) {
        parent.classList.remove('cart-drawer__footer--hidden');
      } else if (!parent.classList.contains('cart-drawer__footer--hidden')) {
        parent.classList.add('cart-drawer__footer--hidden');
      }

      const progressEl = parent.querySelector('[data-free-shipping-progress]');
      const progress = progressEl ? progressEl.getAttribute('data-free-shipping-progress') : '1';

      if (!cart_item_ids.includes(prd_id)) {
        if (giftCard) giftCard.style.display = '';
        if (progress != '1') {
          add_form.style.display = 'none';
          locked.style.display = 'block';
        } else {
          add_form.style.display = 'block';
          locked.style.display = 'none';
        }
      } else {
        if (giftCard) giftCard.style.display = 'none';
      }
    };

    updateGiftWrapper('cart_free_gift--wrapper', 'data-free-gift-id');
    updateGiftWrapper('cart_second_threshold_gift--wrapper', 'data-second-threshold-id');
};

const observer = new MutationObserver(free_gift_mutation);
const config = { childList: true, attributes: true, characterData: true, subtree: true };
targetElements.forEach(element => observer.observe(element, config));

//////////////////////////////////////////////////////////////////////
{
//   document.querySelector('.ctm_btn.add-to-cart')?.addEventListener('click', function () {
//     // console.log('clicked');
//     const freeGiftPrdId = document.querySelector('.cart_free_gift__add_form--var-selector')?.value;
//     if (!freeGiftPrdId) return;

//     const items = [{
//       id: freeGiftPrdId,
//       quantity: 1
//     }];

//     try {
//       const formData = { items };
//       fetch('/cart/add.js', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify(formData)
//       })
//       .then(response => {
//         if (response.ok) {
//           location.reload();
//         } else {
//           throw new Error('Failed to add item');
//         }
//       })
//       .catch(error => console.error('Error:', error));
//     } catch (error) {
//       console.error('Error:', error);
//     }
//   });
  
// }

/* Refresh the cart-form via Section Rendering API instead of doing a full page reload —
     keeps observers, scroll position, and other client state intact while the threshold
     bars/cards/items re-render with up-to-date server state. */
  const refreshCartFromSections = (sectionId) => {
    if (!sectionId) return Promise.resolve();
    return fetch('/?sections=' + encodeURIComponent(sectionId), { credentials: 'same-origin' })
      .then(r => r.json())
      .then(data => {
        const html = data[sectionId];
        if (!html) return;
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const newCartForm = doc.querySelector('cart-form[data-section-id="' + sectionId + '"]') || doc.querySelector('cart-form');
        const curCartForm = document.querySelector('cart-form[data-section-id="' + sectionId + '"]') || document.querySelector('cart-form');
        if (newCartForm && curCartForm) {
          curCartForm.innerHTML = newCartForm.innerHTML;
          /* Drawer cart items (and cross-sell blocks) render with loading="manual", i.e.
             data-manual-src instead of src. The merge path activates these on
             'on:cart:after-merge', but this innerHTML swap bypasses that — so do it here,
             otherwise the freshly-rendered item images stay blank. */
          if (window.theme && typeof theme.manuallyLoadImages === 'function') {
            theme.manuallyLoadImages(curCartForm);
          }
          curCartForm.querySelectorAll('cc-cart-cross-sell').forEach(el => {
            if (typeof el.init === 'function') el.init();
          });
          /* Re-execute inline scripts inside the replaced subtree so threshold observers
             rebind against the new DOM. innerHTML doesn't run <script> tags by itself. */
          curCartForm.querySelectorAll('script').forEach(oldScript => {
            const newScript = document.createElement('script');
            for (const attr of oldScript.attributes) newScript.setAttribute(attr.name, attr.value);
            newScript.textContent = oldScript.textContent;
            oldScript.parentNode.replaceChild(newScript, oldScript);
          });
        }
        if (typeof free_gift_Updates === 'function') {
          try { free_gift_Updates(); } catch (e) {}
        }
      });
  };

  /* Wire each threshold-gift add button (gift + second threshold) to the AJAX add-to-cart
     flow. Reading the variant selector inside the same card the button lives in ensures the
     correct product is added when the active tier advances from gift → second. */
 document.body.addEventListener('click', function (e) {
    const btn = e.target.closest('.ctm_btn.add-to-cart');
    if (!btn) return;
    /* Only intercept clicks on the threshold-gift cards (which live inside cart-form). */
    const cartForm = btn.closest('cart-form');
    if (!cartForm) return;
    const card = btn.closest('.cart_free_gift__add_form') || btn.closest('.cart_free_gift');
    if (!card) return;

    const freeGiftPrdId = card.querySelector('.cart_free_gift__add_form--var-selector')?.value;
    if (!freeGiftPrdId) return;

    e.preventDefault();
    const sectionId = cartForm.getAttribute('data-section-id');
    const items = [{ id: freeGiftPrdId, quantity: 1 }];

    /* Mirror the cart-drawer add-to-cart flow (main.js handleSubmit): spinner via
       `is-loading`, then the success tick via `is-success` for ~2s before cleanup. The
       threshold-gift form already carries `js-product-form` and the button uses
       `name="add"`, so the `.js-product-form [name=add]` spinner/tick CSS in main.css
       applies as-is. The section refresh replaces this button, so it has to wait until
       the tick animation has finished — otherwise the success state never renders. */
    btn.setAttribute('aria-disabled', 'true');
    btn.classList.add('is-loading');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items })
    })
    .then(response => {
      if (!response.ok) throw new Error('Failed to add item');
      return response.json();
    })
    .then(data => {
      if (window.klaviyoTrackAddToCart) window.klaviyoTrackAddToCart(data);
      if (btn.isConnected) {
        btn.classList.add('is-success');
        btn.removeAttribute('aria-disabled');
      }
      return new Promise((resolve) => setTimeout(resolve, 2000))
        .then(() => refreshCartFromSections(sectionId))
        .then(() => {
          if (btn.isConnected) {
            btn.classList.remove('is-loading');
            btn.classList.remove('is-success');
          }
        });
    })
    .catch(error => {
      console.error('Error:', error);
      if (btn.isConnected) {
        btn.classList.remove('is-loading');
        btn.classList.remove('is-success');
        btn.removeAttribute('aria-disabled');
      }
    });
  });

}
//////////////////////////////////////////////////////////////////////


document.addEventListener("DOMContentLoaded", function () {
  const filterConn = document.querySelector("filter-container");

  if (filterConn) {
    const productBlocks = filterConn.querySelectorAll("product-block");

    productBlocks.forEach((block) => {
      block.addEventListener("click", function () {
        // Wait for the popup to fully render
        setTimeout(() => {
          const inputRows = document.querySelectorAll(".product-form .input-row");

          if (inputRows.length > 0) {
            const swatchItemsContainer = inputRows[0];

            const swatchLists = swatchItemsContainer.querySelectorAll(
              "variant-king-combined-listing .swatches ul.swatch-view"
            );

            if (swatchLists.length > 0) {
              swatchLists.forEach((swatchList) => {
                const swatchItems = swatchList.querySelectorAll("li.swatch-view-item");

                swatchItems.forEach((swatchItem) => {
                  const imageWrapper = swatchItem.querySelector(".swatch-custom-image");
                  // console.log(imageWrapper,"=======================");
                  
                  if (imageWrapper) {
                    // Overwrite third-party click logic
                    imageWrapper.addEventListener("click", function (e) {
                      e.preventDefault();           // Prevent default browser behavior
                      e.stopPropagation();          // Stop bubbling up to parents
                      e.stopImmediatePropagation(); // ⛔ Stop other attached listeners (like the third-party one)
                      // console.log("Swatch click blocked");
                    }, true); // Use capture phase to block before 3rd party listener runs
                  }
                });
              });
            }
          }
        }, 3500); // Delay to wait for popup to fully render
      });
    });
  }
});


// =====================


// ===================== slick slider ==================
function initSlickSlider() {
  if ($(window).width() < 768) {
    $('.slider_enabled').each(function () {
      if (!$(this).hasClass('slick-initialized')) {
        $(this).slick({
          dots: false,
          arrows: true,
          infinite: false,
          speed: 800,
          slidesToShow: 4,
          slidesToScroll: 1,
          responsive: [
            { 
              breakpoint: 767,
              settings: {
                slidesToShow: 4,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 700,
              settings: {
                slidesToShow: 4,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 520,
              settings: {
                slidesToShow: 4, 
                slidesToScroll: 1,
                centerMode: false, 
                dots: false,
                arrows: true
              }
            }
          ]
        });
      }
    });
  } else {
    $('.slider_enabled.slick-initialized').slick('unslick');
  }
}

window.addEventListener("facet_filter_change", () => {
  setTimeout(() => {
    initSlickSlider();
  }, 0);
});

// Run on document ready
$(document).ready(function () {
  initSlickSlider();
});

// Run on window resize
$(window).on('resize', function () {
  initSlickSlider();
});

// Helper: Run this after AJAX content is loaded
function reInitSliderAfterAjax() {
  initSlickSlider();
}

document.addEventListener("DOMContentLoaded", function () {

  document.querySelectorAll(".price-row").forEach(function (row) {

    const priceEl = row.querySelector(".price__current");
    const labelEl = row.closest(".associated-product")?.querySelector(".custom-product-label");
    const targetEl = row.querySelector(".per-item_price");

    if (!priceEl || !targetEl || !labelEl) return;

    // Get numeric price from .price__current (removes currency symbols)
    const priceValue = parseFloat(
      priceEl.textContent.replace(/[^0-9.]/g, "")
    );

    // Get numeric bundle/label value
    const labelValue = parseFloat(
      labelEl.textContent.replace(/[^0-9.]/g, "")
    );

    if (!priceValue || !labelValue || labelValue <= 0) {
      targetEl.style.display = "none";
      return;
    }

    // Divide price by label number
    const perItemPrice = (priceValue / labelValue).toFixed(2);

    // Save to attribute
    targetEl.setAttribute("price", perItemPrice);

    // (Optional) show value visually
    targetEl.textContent = perItemPrice;

  });

});


/* Preserve the currently selected variant options (e.g. Size, Color) when the user
   clicks a .custom-product-label link that navigates to an associated product
   (e.g. switching from 1-pack to 2 Packs). The destination is a different product
   so variant IDs don't translate — instead we forward the option *values* as URL
   search params keyed by option name (`?Size=XXL&Color=Red`). variant-picker.js
   already exposes applySearchParams() which re-selects matching radios/dropdowns
   on load, so the size stays selected after the page reload. */
document.addEventListener('click', function (e) {
  const labelEl = e.target.closest('.custom-product-label');
  if (!labelEl) return;

  const linkEl = labelEl.closest('a[href]');
  if (!linkEl) return;

  const href = linkEl.getAttribute('href');
  if (!href || href.startsWith('#') || href.startsWith('javascript:')) return;

  /* Read selected option from the primary variant-picker selectors only. There can
     be additional Color fieldsets inside .customSwatchesCon (bundle products) that
     share the same data-option name, so dedupe by name and keep the first match. */
  const seen = new Set();
  const params = [];
  document.querySelectorAll('variant-picker .option-selector[data-option]').forEach((selector) => {
    const optName = selector.dataset.option;
    if (!optName || seen.has(optName)) return;

    let value = null;
    if (selector.dataset.selectorType === 'dropdown') {
      const selected = selector.querySelector('.custom-select__option[aria-selected="true"]');
      value = selected && selected.dataset.value ? selected.dataset.value : null;
    } else {
      const checkedInput = selector.querySelector('input:checked');
      value = checkedInput ? checkedInput.value : null;
    }

    if (value) {
      seen.add(optName);
      params.push([optName, value]);
    }
  });

  if (!params.length) return;

  try {
    const url = new URL(href, window.location.origin);
    params.forEach(([k, v]) => url.searchParams.set(k, v));
    /* Drop ?variant=… — variant IDs are per-product, so the value from the current
       page would be wrong on the destination product and override our option params. */
    url.searchParams.delete('variant');
    linkEl.setAttribute('href', url.pathname + url.search + url.hash);
  } catch (err) {
    /* If URL parsing fails (e.g. unusual href), leave the original href untouched. */
  }
}, true);
